const ru = {
  "product.scheme.form.code.paste-nut": "Паста",
  "product.item.code.hazelnut": "фундук",
  "app.page.user.title": "пользователи",
  "app.page.user.sendInvite": "отправить приглашение",
  "app.page.user.email": "email",
  "app.page.user.selectRole": "укажите роль",
  "app.page.user.send": "отправить",
  "app.page.user.residentsData": "данные резидентов",
  "app.page.user.name": "имя",
  "app.page.user.post": "почта",
  "app.page.user.phone": "телефон",
  "app.page.user.role": "роль",
  "app.page.user.more": "подробнее",
  "app.page.user.roleAssignment": "назначение ролей",
  "app.page.user.delete": "удалить",
  "app.page.user.removeSelected": "снять выделение",
  "app.page.user.modal.title": "Удаление аккаунта",
  "app.page.user.modal.content": "Вы хотите удалить выбранный(-е) аккаунт(ы)?",
  "app.page.user.modal.delete": "удалить",
  "app.page.user.modal.cancel": "отменить",
  "app.page.appRole.title": "Роли",
  "app.page.appRole.businessObjectAndRoles.businessObject": "бизнес объекты",
  "app.page.appRole.businessObjectAndRoles.roles": "роли",
  "app.page.appRole.businessObjectAndRoles.admin_console": "доступ в консоль администратора",
  "app.page.appRole.businessObjectAndRoles.cabinet": "доступ в кабинет",
  "app.page.appRole.businessObjectAndRoles.user": "пользователи",
  "app.page.preference.item": "предпочтения",
  "app.page.appRole.businessObjectAndRoles.meal": "приемы пищи",
  "app.page.appRole.businessObjectAndRoles.recipe": "рецепты",
  "app.page.appRole.businessObjectAndRoles.recipe_type": "тип рецепта",
  "app.page.appRole.businessObjectAndRoles.product": "продукты",
  "app.page.appRole.businessObjectAndRoles.product_scheme": "схемы продуктов",
  "app.page.appRole.businessObjectAndRoles.preference": "предпочтения",
  "app.page.appRole.businessObjectAndRoles.user_preference": "пользовательские предпочтения",
  "app.page.appRole.businessObjectAndRoles.auth": "аутентификация",
  "app.page.appRole.businessObjectAndRoles.object": "объект",
  "app.page.product.title": "Продукты",
  "app.page.product.filter": "фильтр",
  "app.page.product.addProduct": "добавить продукт",
  "app.page.product.addProductSmall": "добавить",
  "app.page.product.saveChanges": "сохранить изменения",
  "app.page.product.saveChangesSmall": "сохранить",
  "app.page.product.editProduct": "изменить продукт",
  "app.page.product.selectFromList": "выберите значение",
  "app.page.product.minValue": "минимальное значение",
  "app.page.product.maxValue": "максимальное значение",
  "app.page.product.productSearch": "поиск продукта",
  "app.page.product.formSearch": "поиск формы",
  "app.page.product.addForm": "добавить форму",
  "app.page.product.downloadCSV": "выгрузить в csv",
  "app.page.product.exportingCSV": "выгрузка...",
  "app.page.product.form.downloadCSV": "выгрузить в csv",
  "app.page.product.property.downloadCSV": "выгрузить в csv",
  "app.page.recipe.downloadCSV": "выгрузить в csv",
  "app.page.product.editForm": "изменить форму",
  "app.page.product.addProperty": "добавить свойство",
  "app.page.product.editProperty": "изменить свойство",
  "app.page.product.referenceBook": "справочник",
  "app.page.product.referenceBookNone": "не указан",
  "app.page.product.add": "добавить",
  "app.page.product.compositionBasis": "основа состава",
  "app.page.product.variantKind": "вид варианта",
  "app.page.product.flourGrainKind": "мука: зерно",
  "app.page.product.flourMillingGrade": "мука: сорт",
  "app.page.product.variants": "варианты",
  "app.page.product.related": "связанные",
  "app.page.product.compositionCheck.title": "полнота состава макро",
  "app.page.product.compositionCheck.loading": "проверка…",
  "app.page.product.compositionCheck.provenance": "справочник",
  "app.page.product.compositionCheck.hint": "только предупреждения; сохранение, импорт и generate не блокируются",
  "app.page.product.compositionCheck.status.complete": "полный",
  "app.page.product.compositionCheck.status.partial": "частичный",
  "app.page.product.compositionCheck.status.not-comparable": "несравнимо",
  "app.page.product.compositionCheck.branch.protein": "белок",
  "app.page.product.compositionCheck.branch.fat": "жир",
  "app.page.product.compositionCheck.branch.carbohydrate": "углеводы",
  "app.page.product.compositionCheck.rule.protein_aa_sum": "сумма аминокислот {{sum}} г/100 г больше белка {{parent}} (допуск {{tolerance}})",
  "app.page.product.compositionCheck.rule.fat_subtotal_sum": "SFA+MUFA+PUFA {{sum}} г/100 г больше жира {{parent}} (допуск {{tolerance}})",
  "app.page.product.compositionCheck.rule.sugars_sum": "сумма сахаров {{sum}} г/100 г больше total-sugars {{parent}} (допуск {{tolerance}})",
  "app.page.product.compositionCheck.rule.starch_sum": "амилоза+амилопектин {{sum}} г/100 г больше крахмала {{parent}} (допуск {{tolerance}})",
  "app.page.product.close": "закрыть",
  "app.page.product.productFormName": "форма продукта",
  "app.page.product.addFormItem.formName": "Имя формы",
  "app.page.product.addFormItem.formCode": "Код формы",
  "app.page.product.addFormItem.formGroup": "Группа формы",
  "app.page.product.addFormItem.formType": "Тип формы",
  "app.page.product.productTab.product": "продукты",
  "app.page.product.productTab.form": "формы",
  "app.page.product.productTab.property": "свойства",
  "app.page.product.productFormTab.physical": "физические свойства",
  "app.page.product.productFormTab.macronutrient": "макронутриенты",
  "app.page.product.productFormTab.micronutrient": "микронутриенты",
  "app.page.product.addProductItem.productName": "Имя продукта",
  "app.page.product.addProductItem.productCode": "Код продукта",
  "app.page.product.modal.form.title": "Удаление формы",
  "app.page.product.modal.form.content": "Вы уверены, что хотите удалить форму?",
  "app.page.product.modal.form.delete": "удалить",
  "app.page.product.modal.form.cancel": "отменить",
  "app.page.product.modal.item.title": "Удаление продукта",
  "app.page.product.modal.item.content": "Вы уверены, что хотите удалить продукт?",
  "app.page.product.modal.item.delete": "удалить",
  "app.page.product.modal.item.cancel": "отменить",
  "app.page.product.modal.property.title": "Удаление свойства",
  "app.page.product.modal.property.content": "Вы уверены, что хотите удалить свойство?",
  "app.page.product.modal.property.delete": "удалить",
  "app.page.product.modal.property.cancel": "отменить",
  "app.page.product.filters.fat": "Содержание жиров",
  "app.page.product.filters.proteins": "Содержание белка",
  "app.page.product.filters.carbohydrates": "Содержание углеводов",
  "app.page.product.filters.mineralsValue": "Содержание минералов",
  "app.page.product.filters.vitaminsValue": "Содержание витаминов",
  "app.page.product.filters.type": "Вид продукта",
  "app.page.product.filters.form": "Форма продукта",
  "app.page.product.filters.color": "Цвет продукта",
  "app.page.product.filters.energy": "Энергия",
  "app.page.product.filters.cancel": "отменить",
  "app.page.product.filters.applyFilter": "применить фильтр",
  "app.page.product.propertyItem.propertyType": "тип свойства",
  "app.page.product.propertyItem.categoryName": "категория",
  "app.page.product.propertyItem.propertyName": "название свойства",
  "app.page.product.propertyItem.propertyCode": "код свойства",
  "app.page.product.propertyItem.values": "значения",
  "app.page.product.propertyItem.selectValues": "перечислите значения",
  "app.page.product.propertyItem.description": "описание",
  "app.page.product.propertyItem.synonyms": "Синонимы (отображение)",
  "app.page.product.propertyItem.text": "текст",
  "app.page.preference.title": "Предпочтения",
  "app.page.preference.filter": "фильтр",
  "app.page.preference.addPreference": "добавить предпочтение",
  "app.page.preference.savePreference": "сохранить изменения",
  "app.page.preference.addPreferenceSmall": "добавить",
  "app.page.preference.savePreferenceSmall": "сохранить",
  "app.page.preference.selectFromList": "выберите значение",
  "app.page.preference.preferenceSearch": "поиск предпочтения",
  "app.page.preference.enterInfo": "введите информацию",
  "app.page.preference.editPreference": "изменить предпочтение",
  "app.page.preference.applyFilter": "применить фильтр",
  "app.page.preference.cancel": "отмена",
  "app.page.preference.preferenceAssignment": "назначение предпочтения",
  "app.page.preference.userSearch": "поиск пользователя",
  "app.page.preference.userName": "имя пользователя",
  "app.page.preference.userPhone": "номер телефона",
  "app.page.preference.selected": "Выбрано",
  "app.page.preference.preference": "предпочтение",
  "app.page.preference.preferences": "предпочтений",
  "app.page.preference.total": "Всего",
  "app.page.preference.assignGroup": "Назначить группу",
  "app.page.preference.assignUser": "Назначить пользователя",
  "app.page.preference.modal.title": "удаление предпочтения",
  "app.page.preference.modal.content": "Вы уверены, что хотите удалить предпочтение?",
  "app.page.preference.modal.delete": "удалить",
  "app.page.preference.modal.cancel": "отмена",
  "app.page.preference.modal.assign": "назначить",
  "app.page.preference.addTitles.include": "Хочу/Не хочу",
  "app.page.preference.addTitles.preferenceType": "Что хочу?",
  "app.page.preference.addTitles.when": "Когда?",
  "app.page.preference.addTitles.isInternal": "Внутренний?",
  "app.page.preference.addTitles.whichGroup": "Какая группа?",
  "app.page.preference.addTitles.phrase": "Фраза",
  "app.page.preference.addTitles.preferenceLabels": "Какая группа?",
  "app.page.recipe.title": "Рецепты",
  "app.page.generation-trace.title": "Генерация meal",
  "app.page.generationTrace.title": "Следы генерации meal",
  "app.page.generationTrace.back": "К списку",
  "app.page.generationTrace.userId": "User ID",
  "app.page.generationTrace.outcome": "Исход",
  "app.page.generationTrace.anyOutcome": "Любой исход",
  "app.page.generationTrace.skipReason": "Причина skip",
  "app.page.generationTrace.applyFilters": "Применить",
  "app.page.generationTrace.from": "С",
  "app.page.generationTrace.to": "По",
  "app.page.generationTrace.empty": "Пока нет следов",
  "app.page.generationTrace.total": "Всего",
  "app.page.generationTrace.createdAt": "Создано",
  "app.page.generationTrace.mealType": "Тип",
  "app.page.generationTrace.recipeId": "Recipe ID",
  "app.page.generationTrace.mealId": "Meal ID",
  "app.page.generationTrace.targetKcal": "Target kcal",
  "app.page.generationTrace.actualKcal": "Actual kcal",
  "app.page.generationTrace.open": "Открыть",
  "app.page.generationTrace.summary": "Summary",
  "app.page.generationTrace.timeline": "Timeline",

  "app.page.reference-books.title": "Справочники",
  "app.page.menu.collapse": "Свернуть меню",
  "app.page.menu.expand": "Развернуть меню",
  "app.page.svg-library.title": "Библиотека SVG",
  "app.page.svg-library.hint": "Общие иллюстрации для продуктов. Редактируйте в Draw и сохраняйте в библиотеку.",
  "app.page.svg-library.new": "Создать",
  "app.page.svg-library.newTitle": "Новый SVG",
  "app.page.svg-library.editTitle": "Редактирование SVG",
  "app.page.svg-library.search": "Найти",
  "app.page.svg-library.searchPlaceholder": "Поиск по названию или коду",
  "app.page.svg-library.empty": "Пока нет ассетов",
  "app.page.svg-library.back": "К библиотеке",
  "app.page.svg-library.saving": "Сохранение…",
  "app.page.svg-library.titlePlaceholder": "Название",
  "app.page.svg-library.tagsPlaceholder": "Теги через запятую",
    "app.page.svg-library.untitled": "Без названия",
    "app.page.svg-library.untitledContour": "Контур",
  "app.page.svg-library.unsavedConfirm": "Есть несохранённые изменения. Уйти?",
  "app.page.svg-library.svgTooLarge": "SVG больше {{max}} КБ",
  "app.page.svg-library.chapdrawTooLarge": "Черновик больше {{max}} МБ",
  "app.page.svg-library.saveError": "Не удалось сохранить",
  "app.page.svg-library.loadError": "Не удалось загрузить",
  "app.page.svg-library.conflict": "Ассет изменили в другом месте. Обновите и повторите.",
  "app.page.svg-library.reload": "Перезагрузить",
  "app.page.svg-library.allTags": "Все теги",
  "app.page.svg-library.downloadSvg": "Скачать SVG",
  "app.page.svg-library.downloadChapdraw": "Скачать .chapdraw",
  "app.page.product.edit.svg.title": "Иллюстрации",
  "app.page.product.edit.svg.hint": "Привяжите один или несколько ассетов из библиотеки SVG. Один должен быть primary.",
  "app.page.product.edit.svg.add": "Добавить из библиотеки",
  "app.page.product.edit.svg.primary": "Основная",
  "app.page.product.edit.svg.setPrimary": "Сделать основной",
  "app.page.product.edit.svg.detach": "Отвязать",
  "app.page.product.edit.svg.openDraw": "Открыть в Draw",
  "app.page.product.edit.svg.empty": "Иллюстрации не привязаны",
  "app.page.product.edit.svg.pick": "Выберите ассет для привязки",
  "app.page.product.edit.svg.up": "Выше",
  "app.page.product.edit.svg.down": "Ниже",
  "app.page.recipe.edit.svg.title": "Иллюстрации",
  "app.page.recipe.edit.svg.hint": "Привяжите один или несколько ассетов из библиотеки SVG. Один должен быть primary.",
  "app.page.recipe.edit.svg.add": "Добавить из библиотеки",
  "app.page.recipe.edit.svg.primary": "Основная",
  "app.page.recipe.edit.svg.setPrimary": "Сделать основной",
  "app.page.recipe.edit.svg.detach": "Отвязать",
  "app.page.recipe.edit.svg.openDraw": "Открыть в Draw",
  "app.page.recipe.edit.svg.empty": "Иллюстрации не привязаны",
  "app.page.recipe.edit.svg.pick": "Выберите ассет для привязки",
  "app.page.recipe.edit.svg.up": "Выше",
  "app.page.recipe.edit.svg.down": "Ниже",
  "app.page.grain-liquid-ratios.title": "Пропорции крупа/жидкость",
  "app.page.grain-liquid-ratios.hint": "Эталонные пропорции для каши: продукт или категория × консистенция × жидкость. Объёмы в шагах готовки считаются из этих значений.",
  "app.page.grain-liquid-ratios.exportCsv": "Выгрузить CSV",
  "app.page.grain-liquid-ratios.importCsv": "Загрузить CSV",
  "app.page.grain-liquid-ratios.addTitle": "Новая пропорция",
  "app.page.grain-liquid-ratios.addHint": "Укажите код продукта или категорию (можно оба). Жидкость по умолчанию — вода.",
  "app.page.grain-liquid-ratios.create": "Добавить",
  "app.page.grain-liquid-ratios.edit": "Изменить",
  "app.page.grain-liquid-ratios.save": "Сохранить",
  "app.page.grain-liquid-ratios.cancel": "Отмена",
  "app.page.grain-liquid-ratios.delete": "Удалить",
  "app.page.grain-liquid-ratios.empty": "Пропорции ещё не заданы",
  "app.page.grain-liquid-ratios.columns.actions": "Действия",
  "app.page.grain-liquid-ratios.importSuccess": "Импорт выполнен: обновлено {{count}}",
  "app.page.grain-liquid-ratios.importFailed": "Не удалось импортировать CSV",
  "app.page.grain-liquid-ratios.fields.productCode": "Продукт",
  "app.page.grain-liquid-ratios.fields.productCodePlaceholder": "например, rice",
  "app.page.grain-liquid-ratios.product.empty": "Не задан",
  "app.page.grain-liquid-ratios.fields.productCategory": "Категория",
  "app.page.grain-liquid-ratios.fields.consistencyCode": "Консистенция",
  "app.page.grain-liquid-ratios.fields.liquidKind": "Жидкость",
  "app.page.grain-liquid-ratios.fields.liquidPerGrain": "Жидкость на 1 часть крупы",
  "app.page.grain-liquid-ratios.fields.liquidPerGrainPlaceholder": "например, 2",
  "app.page.grain-liquid-ratios.fields.basis": "Единица расчёта",
  "app.page.grain-liquid-ratios.columns.product": "Продукт",
  "app.page.grain-liquid-ratios.columns.category": "Категория",
  "app.page.grain-liquid-ratios.columns.consistency": "Консистенция",
  "app.page.grain-liquid-ratios.columns.liquid": "Жидкость",
  "app.page.grain-liquid-ratios.columns.ratio": "Пропорция",
  "app.page.grain-liquid-ratios.columns.basis": "Единица",
  "app.page.grain-liquid-ratios.liquid.water": "Вода",
  "app.page.grain-liquid-ratios.liquid.milk": "Молоко",
  "app.page.grain-liquid-ratios.liquid.plant-milk": "Растительное молоко",
  "app.page.grain-liquid-ratios.liquid.any": "Любая",
  "app.page.grain-liquid-ratios.liquid.kindCollapse.plant-milk": "Свёртка: растительное молоко",
  "app.page.grain-liquid-ratios.liquid.kindCollapse.any": "Свёртка: любая",
  "app.page.grain-liquid-ratios.basis.volume": "Объём",
  "app.page.grain-liquid-ratios.basis.mass": "Масса",
  "app.page.grain-liquid-ratios.category.empty": "Не задана",
  "app.page.grain-liquid-ratios.category.grain": "Крупа",
  "app.page.grain-liquid-ratios.validation.productOrCategory": "Укажите код продукта или категорию",
  "app.page.grain-liquid-ratios.validation.consistencyRequired": "Выберите консистенцию",
  "app.page.grain-liquid-ratios.validation.liquidRequired": "Выберите жидкость",
  "app.page.grain-liquid-ratios.validation.ratioPositive": "Пропорция должна быть больше 0",
  "app.page.grain-liquid-ratios.validation.basisInvalid": "Выберите единицу расчёта: объём или масса",
  "app.page.referenceBooks.title": "Справочники",
  "app.page.referenceBooks.listHint": "Книги химического состава и другие composition-справочники.",
  "app.page.referenceBooks.backToList": "К списку",
  "app.page.referenceBooks.backToBook": "К справочнику",
  "app.page.referenceBooks.code": "Код",
  "app.page.referenceBooks.bookTitle": "Название",
  "app.page.referenceBooks.tableTitle": "Таблица",
  "app.page.referenceBooks.kind": "Тип",
  "app.page.referenceBooks.status": "Статус",
  "app.page.referenceBooks.year": "Год",
  "app.page.referenceBooks.authors": "Авторы / редакторы",
  "app.page.referenceBooks.tables": "Таблицы",
  "app.page.referenceBooks.tablesCount": "Таблиц",
  "app.page.referenceBooks.tableKind": "Тип таблицы",
  "app.page.referenceBooks.rowsCount": "Строк",
  "app.page.referenceBooks.open": "Открыть",
  "app.page.referenceBooks.label": "Название строки",
  "app.page.referenceBooks.rowKind": "Вид строки",
  "app.page.referenceBooks.heatHint": "Термообработка",
  "app.page.referenceBooks.protein": "Белок %",
  "app.page.referenceBooks.fat": "Жир %",
  "app.page.referenceBooks.carb": "Угл %",
  "app.page.referenceBooks.basis": "Базис",
  "app.page.referenceBooks.searchPlaceholder": "Поиск по названию или коду",
  "app.page.referenceBooks.applyFilters": "Применить",
  "app.page.referenceBooks.downloadCsv": "Скачать CSV",
  "app.page.referenceBooks.total": "Всего",
  "app.page.referenceBooks.prev": "Назад",
  "app.page.referenceBooks.next": "Далее",
  "app.page.referenceBooks.pageRange": "{{from}}–{{to}} из {{total}}",
  "app.page.referenceBooks.boolean.true": "да",
  "app.page.referenceBooks.boolean.false": "нет",
  "app.page.referenceBooks.rowKindValue.product": "продукт",
  "app.page.referenceBooks.rowKindValue.category": "категория",
  "app.page.referenceBooks.rowKindValue.recipe": "рецепт",
  "app.page.referenceBooks.col.page": "Стр.",
  "app.page.referenceBooks.col.table_no": "Табл.",
  "app.page.referenceBooks.col.code": "Код",
  "app.page.referenceBooks.col.label": "Название",
  "app.page.referenceBooks.col.is_category": "Категория",
  "app.page.referenceBooks.col.water_pct": "Вода %",
  "app.page.referenceBooks.col.protein_pct": "Белок %",
  "app.page.referenceBooks.col.fat_pct": "Жир %",
  "app.page.referenceBooks.col.sfa_pct": "НЖК %",
  "app.page.referenceBooks.col.chol_mg_pct": "Хол. мг%",
  "app.page.referenceBooks.col.mds_pct": "МДС %",
  "app.page.referenceBooks.col.starch_pct": "Крахмал %",
  "app.page.referenceBooks.col.carb_pct": "Угл. %",
  "app.page.referenceBooks.col.fiber_pct": "ПВ %",
  "app.page.referenceBooks.col.org_acid_pct": "Орг. к-ты %",
  "app.page.referenceBooks.col.ash_pct": "Зола %",
  "app.page.referenceBooks.col.na_mg_pct": "Na мг%",
  "app.page.referenceBooks.col.pufa_pct": "ПНЖК %",
  "app.page.referenceBooks.col.row_kind": "Вид",
  "app.page.referenceBooks.col.is_recipe": "Рецепт",
  "app.page.referenceBooks.col.chapche_product_code": "Код продукта",
  "app.page.referenceBooks.col.chapche_recipe_code": "Код рецепта",
  "app.page.referenceBooks.col.heat_treatment_hint": "Термообработка",
  "app.page.referenceBooks.col.notes": "Заметки",
  "app.page.referenceBooks.col.k_mg_pct": "K мг%",
  "app.page.referenceBooks.col.ca_mg_pct": "Ca мг%",
  "app.page.referenceBooks.col.mg_mg_pct": "Mg мг%",
  "app.page.referenceBooks.col.p_mg_pct": "P мг%",
  "app.page.referenceBooks.col.fe_mg_pct": "Fe мг%",
  "app.page.referenceBooks.col.vit_a_ug_pct": "A мкг%",
  "app.page.referenceBooks.col.carotene_ug_pct": "Каротин мкг%",
  "app.page.referenceBooks.col.re_ug_pct": "РЭ мкг%",
  "app.page.referenceBooks.col.te_mg_pct": "ТЭ мг%",
  "app.page.referenceBooks.col.b1_mg_pct": "B1 мг%",
  "app.page.referenceBooks.col.b2_mg_pct": "B2 мг%",
  "app.page.referenceBooks.col.pp_mg_pct": "PP мг%",
  "app.page.referenceBooks.col.ne_mg_pct": "НЭ мг%",
  "app.page.referenceBooks.col.vit_c_mg_pct": "C мг%",
  "app.page.referenceBooks.col.energy_kcal": "ЭЦ ккал",
  "app.page.referenceBooks.col.fdc_id": "FDC id",
  "app.page.referenceBooks.col.ndb_number": "NDB",
  "app.page.referenceBooks.col.food_category": "Категория FDC",
  "app.page.referenceBooks.col.food_category_id": "ID категории",
  "app.page.referenceBooks.col.publication_date": "Дата публикации",
  "app.page.referenceBooks.col.energy": "Энергия",
  "app.page.referenceBooks.col.moisture": "Влага",
  "app.page.referenceBooks.col.protein": "Белок",
  "app.page.referenceBooks.col.fat": "Жир",
  "app.page.referenceBooks.col.carbohydrate": "Углеводы",
  "app.page.referenceBooks.col.alimentary-fiber": "Клетчатка",
  "app.page.referenceBooks.col.sugar": "Сахар",
  "app.page.referenceBooks.col.total-ash": "Зола",
  "app.page.referenceBooks.col.saturated-fatty-acids": "НЖК",
  "app.page.referenceBooks.col.monounsaturated-fatty-acids": "МНЖК",
  "app.page.referenceBooks.col.polyunsaturated-fatty-acids": "ПНЖК",
  "app.page.referenceBooks.col.cholesterol": "Холестерин",
  "app.page.referenceBooks.col.sodium": "Натрий",
  "app.page.referenceBooks.col.potassium": "Калий",
  "app.page.referenceBooks.col.calcium": "Кальций",
  "app.page.referenceBooks.col.magnesium": "Магний",
  "app.page.referenceBooks.col.phosphorus": "Фосфор",
  "app.page.referenceBooks.col.ferrum": "Железо",
  "app.page.referenceBooks.col.zinc": "Цинк",
  "app.page.referenceBooks.col.cuprum": "Медь",
  "app.page.referenceBooks.col.selenium": "Селен",
  "app.page.referenceBooks.col.vitamin-a": "Витамин A",
  "app.page.referenceBooks.col.beta-carotene": "β-каротин",
  "app.page.referenceBooks.col.ascorbic-acid": "Витамин C",
  "app.page.referenceBooks.col.thiamine": "Тиамин",
  "app.page.referenceBooks.col.riboflavin": "Рибофлавин",
  "app.page.referenceBooks.col.niacin": "Ниацин",
  "app.page.referenceBooks.col.pyridoxine": "Пиридоксин",
  "app.page.referenceBooks.col.folic-acid": "Фолиевая к-та",
  "app.page.referenceBooks.col.tocopherol-equivalent": "Токоферол",
  "app.page.referenceBooks.col.vitamin-b12": "Витамин B12",
  "app.page.referenceBooks.col.vitamin-d": "Витамин D",
  "app.page.referenceBooks.col.vitamin-k": "Витамин K",
  "app.page.recipe.recipeTab.item": "рецепты",
  "app.page.recipe.recipeTab.cookingStep": "шаги приготовления",
  "app.page.recipe.filter": "фильтр",
  "app.page.recipe.recipeSearch": "поиск рецепта",
  "app.page.recipe.recipeCode": "код рецепта",
  "app.page.recipe.base": "основные ингредиенты",
  "app.page.recipe.adds": "дополнительные ингредиенты",
  "app.page.recipe.addsShort": "дополнительные",
  "app.page.recipe.tasty": "для улучшения вкуса",
  "app.page.recipe.tastyShort": "для вкуса",
  "app.page.recipe.liquid": "жидкость",
  "app.page.recipe.liquidShort": "жидкость",
  "app.page.recipe.liquidHint": "В meal выбирается одна жидкость (граммы — из пропорции крупа∶жидкость).",
  "app.page.recipe.defaultKashaConsistency": "консистенция каши по умолчанию",
  "recipe.scheme.kashaConsistency.fluffy": "рассыпчатая",
  "recipe.scheme.kashaConsistency.creamy": "разваренная",
  "recipe.scheme.kashaConsistency.sticky": "вязкая",
  "preference.scheme.preferenceType.kasha-consistency": "консистенция каши",
  "preference.scheme.preferenceItem.kasha-consistency-fluffy": "рассыпчатая",
  "preference.scheme.preferenceItem.kasha-consistency-creamy": "разваренная",
  "preference.scheme.preferenceItem.kasha-consistency-sticky": "вязкая",
  "app.page.recipe.groupShare": "доля группы, %",
  "app.page.recipe.unitWeight": "относительный вес единицы",
  "app.page.recipe.heatTreatment": "тепловая обработка",
  "app.page.recipe.heatTreatment.none": "не указана",
  "app.page.recipe.heatTreatment.raw": "сырой",
  "app.page.recipe.heatTreatment.boiled": "варёный",
  "app.page.recipe.heatTreatment.steamed": "на пару",
  "app.page.recipe.heatTreatment.baked": "запечённый",
  "app.page.recipe.heatTreatment.roasted": "жареный (в духовке)",
  "app.page.recipe.heatTreatment.broiled": "гриль",
  "app.page.recipe.heatTreatment.fried": "жареный",
  "app.page.recipe.heatTreatment.sauteed": "обжаренный",
  "app.page.recipe.heatTreatment.stewed": "тушёный",
  "app.page.recipe.heatTreatment.poached": "приготовленный в воде",
  "app.page.recipe.heatTreatment.microwaved": "в микроволновке",
  "app.page.recipe.heatTreatment.dried": "сушёный",
  "app.page.recipe.heatTreatment.sous-vide": "су-вид",
  "app.page.recipe.heatTreatment.pressure-cooked": "в скороварке",
  "app.page.recipe.amountKind": "мера",
  "app.page.recipe.amountKind.teaspoon": "чайная ложка",
  "app.page.recipe.amountKind.pinch": "щепотка",
  "app.page.recipe.amountKind.to_taste": "по вкусу",
  "app.page.recipe.amountKind.gram": "грамм",
  "app.page.recipe.amountValue": "количество",
  "app.page.recipe.addProduct": "добавить продукт",
  "app.page.recipe.applyFilter": "применить фильтр",
  "app.page.recipe.cancel": "отмена",
  "app.page.recipe.product": "продукт",
  "app.page.recipe.productState": "состояние продукта",
  "app.page.recipe.productCode": "код продукта",
  "app.page.recipe.addRecipe": "добавить рецепт",
  "app.page.recipe.saveChanges": "сохранить изменения",
  "app.page.recipe.editRecipe": "изменить рецепт",
  "app.page.recipe.name": "наименование",
  "app.page.recipe.modal.title": "удалить рецепт",
  "app.page.recipe.modal.content": "Вы уверены, что хотите удалить рецепт?",
  "app.page.recipe.modal.delete": "удалить",
  "app.page.recipe.modal.cancel": "отменить",
  "app.page.plan.title": "Мой план",
  "app.page.plan.emptyPlan": "План питания отсутствует.",
  "app.page.plan.createPlan": "Создать план питания",
  "app.page.plan.generatePlan": "Генерируем подходящий для Вас план питания",
  "app.page.plan.create": "Создайте",
  "app.page.plan.toEat": "план, чтобы съесть что-нибудь",
  "app.page.plan.forWeek": " план",
  "app.page.meal.title": "Приемы пищи",
  "app.page.profile.title": "Профиль",
  "app.page.profile.myData": "мои данные",
  "app.page.profile.history": "история",
  "app.page.profile.email": "email",
  "app.page.profile.name": "имя",
  "app.page.profile.timezone": "часовой пояс",
  "app.page.profile.password": "пароль",
  "app.page.profile.change": "изменить",
  "app.page.profile.emptyData": "данные отсутствуют",
  "app.page.profile.changePassword": "изменить пароль",
  "app.page.profile.changeEmail": "изменить почту",
  "app.page.profile.wrongPassword": "Введен неверный пароль",
  "app.page.profile.confirmEmail": "Требуется подверждение",
  "app.page.profile.lastName": "фамилия",
  "app.page.profile.firstName": "имя",
  "app.page.profile.middleName": "отчество",
  "app.page.profile.phone": "номер телефона",
  "app.page.profile.changePhone": "изменить номер телефона",
  "app.page.profile.modalCabinet.title": "Укажите новый номер",
  "app.page.profile.modalCabinet.content": "На него мы отправим код для подтверждения",
  "app.page.profile.modalCabinet.cancel": "Отмена",
  "app.page.profile.modalCabinet.change": "Получить код",
  "app.page.profile.modal.email.title": "Укажите новую почту",
  "recipe.scheme.recipeType.bread": "хлеб",
  "app.page.profile.modal.email.content": "На нее мы отправим письмо для подтверждения",
  "app.page.profile.modal.email.change": "Изменить",
  "app.page.profile.modal.email.cancel": "Отмена",
  "app.page.profile.modal.password.title": "Изменение пароля",
  "app.page.profile.modal.password.content": "Заполните все поля",
  "app.page.profile.modal.password.change": "Изменить",
  "app.page.profile.modal.password.cancel": "Отмена",
  "app.page.profile.modal.password.currentPassword": "Текущий пароль",
  "app.page.profile.modal.password.newPassword": "Новый пароль",
  "app.page.profile.modal.password.repeatNewPassword": "Подтверждение нового пароля",
  "app.page.preference.deleteCount": "Предпочтений должно быть минимум 5. Чтобы удалить действующее предпочтение, сначала создайте новое",
  "app.page.modal.close": "закрыть",
  "app.page.pagination.first": "первая",
  "app.page.pagination.last": "последняя",
  "appRoles.scheme.userRoles.guest": "гость",
  "appRoles.scheme.userRoles.app-user": "пользователь приложения",
  "appRoles.scheme.userRoles.admin": "администратор",
  "appRoles.scheme.permissions.createPermission": "создание",
  "appRoles.scheme.permissions.deletePermission": "удаление",
  "appRoles.scheme.permissions.modifyAllPermission": "изменение всех",
  "appRoles.scheme.permissions.readPermission": "чтение",
  "appRoles.scheme.permissions.updatePermission": "редактирование",
  "appRoles.scheme.permissions.viewAllPermission": "просмотр всех",
  "preference.scheme.include.true": "хочу",
  "preference.scheme.include.false": "не хочу",
  "preference.scheme.preferenceType.recipe": "рецепт",
  "preference.scheme.preferenceType.product": "продукт",
  "preference.scheme.preferenceType.property": "свойство",
  "preference.scheme.preferenceLabels.basic": "Базовая группа",
  "preference.scheme.preferenceLabels.favorites": "Коллекция питания",
  "days.scheme.daysOfWeek.fr": "пт",
  "preference.scheme.preferenceLabels.season": "Группа сезонности",
  "preference.scheme.when.morning": "утро",
  "preference.scheme.when.after-morning": "после утра",
  "preference.scheme.when.afternoon": "обед",
  "preference.scheme.when.before-evening": "перед вечером",
  "preference.scheme.when.evening": "вечер",
  "preference.scheme.when.night": "ночь",
  "preference.scheme.when.whole-day": "весь день",
  "preference.scheme.when.now": "сейчас",
  "preference.scheme.when.today": "сегодня",
  "preference.scheme.when.tomorrow": "завтра",
  "preference.scheme.when.week": "на неделю",
  "preference.scheme.isInternal.true": "да",
  "preference.scheme.isInternal.false": "нет",
  "ingredient.scheme.ingredientForm.liquid": "жидкий",
  "ingredient.scheme.ingredientForm.boiled": "вареный",
  "ingredient.scheme.ingredientForm.smallCrashed": "мелко порезанный",
  "ingredient.scheme.ingredientForm.paste": "паста",
  "ingredient.scheme.ingredientForm.raw": "сырой",
  "ingredient.scheme.ingredientForm.sliced": "нарезанный",
  "ingredient.scheme.ingredientForm.ground": "фарш",
  "ingredient.scheme.ingredientForm.dried": "сушеный",
  "ingredient.scheme.ingredientForm.sauce": "соус",
  "ingredient.scheme.ingredientForm.thick": "густой",
  "ingredient.scheme.ingredientForm.steamed": "на пару",
  "ingredient.scheme.ingredientForm.fried": "жаренный с маслом",
  "ingredient.scheme.ingredientForm.sous-vide": "в вакууме",
  "ingredient.scheme.ingredientForm.softBoiled": "всмятку",
  "ingredient.scheme.ingredientForm.roast": "жаренный без масла",
  "ingredient.scheme.ingredientForm.canned": "консервированный",
  "ingredient.scheme.ingredientForm.toasted": "поджаренный",
  "ingredient.scheme.ingredientForm.poached": "вареный в кипятке",
  "ingredient.scheme.ingredientForm.salted": "соленый",
  "ingredient.scheme.ingredientForm.spread": "пастообразный",
  "ingredient.scheme.ingredientForm.ball": "шарообразный",
  "ingredient.scheme.ingredientForm.filing": "подача",
  "ingredient.scheme.ingredientForm.baked": "запеченный",
  "ingredient.scheme.ingredientForm.grated": "тертый",
  "recipe.scheme.recipeType.snack": "снэк",
  "recipe.scheme.recipeType.smoothies": "смузи",
  "recipe.scheme.recipeType.granola": "гранола",
  "recipe.scheme.recipeType.kasha": "каша",
  "recipe.scheme.recipeType.bowl": "боул",
  "recipe.scheme.recipeType.soup": "суп",
  "meal.scheme.mealType.snack": "снэк",
  "meal.scheme.mealType.smoothies": "смузи",
  "meal.scheme.mealType.granola": "гранола",
  "meal.scheme.mealType.bread": "хлеб",
  "meal.scheme.mealType.kasha": "каша",
  "meal.scheme.mealType.bowl": "боул",
  "meal.scheme.mealType.soup": "суп",
  "meal.scheme.mealTime.breakfast": "завтрак",
  "meal.scheme.mealTime.lunch": "обед",
  "meal.scheme.mealTime.dinner": "ужин",
  "meal.scheme.mealTime.snack": "закуска",
  "product.scheme.productForm.flesh": "плоть",
  "product.scheme.productForm.pulp": "мякоть",
  "product.scheme.productForm.with-skin": "с кожурой",
  "product.scheme.productForm.whole-grain": "цельнозерновой",
  "product.scheme.productForm.bran": "отруби",
  "product.scheme.productForm.tolokno": "толокно",
  "product.scheme.productForm.flour": "мука",
  "product.scheme.productForm.raw": "сырой",
  "product.scheme.productForm.fry": "жареный",
  "product.scheme.productForm.any": "любая",
  "product.scheme.formType.product-part": "часть продукта",
  "product.scheme.formType.heatTreatment": "тепловая обработка",
  "product.scheme.formGroup.grain": "зерно",
  "product.scheme.formGroup.vegetable": "овощ",
  "product.scheme.formGroup.meat": "мясо",
  "product.scheme.property.propertyType.string": "строка",
  "product.scheme.property.propertyType.select": "выбор значений",
  "product.scheme.property.propertyType.boolean": "булевое значение",
  "product.scheme.property.propertyName.pulp": "мякоть",
  "product.scheme.property.propertyName.with_skin": "с кожурой",
  "product.scheme.property.propertyName.without_skin": "без кожуры",
  "product.scheme.property.propertyName.raw": "сырой",
  "product.scheme.property.propertyName.boiled": "вареный",
  "product.scheme.property.propertyName.from": "от",
  "product.scheme.property.propertyName.to": "до",
  "product.scheme.property.propertyName.vitamins": "Витамины",
  "product.scheme.property.propertyName.season": "Сезон",
  "product.scheme.property.propertyName.vegetable": "Овощ",
  "product.scheme.property.propertyName.fruit": "Фрукт",
  "product.scheme.property.propertyName.berry": "Ягода",
  "product.scheme.property.propertyName.salad": "Салат",
  "product.scheme.property.propertyName.meat": "Мясо",
  "product.scheme.property.propertyName.fish": "Рыба",
  "product.scheme.property.propertyName.grain": "Зерно",
  "product.scheme.property.propertyName.cereal": "Злак",
  "product.scheme.property.propertyName.color": "Цвет",
  "product.scheme.property.propertyName.aspartic-acid": "Аспарагиновая кислота",
  "product.scheme.property.propertyName.butyric-acid": "Масляная кислота",
  "product.scheme.property.propertyName.caproic-acid": "Капроновая кислота",
  "product.scheme.property.propertyName.caprylic-acid": "Каприловая кислота",
  "product.scheme.property.propertyName.capric-acid": "Каприновая кислота",
  "product.scheme.property.propertyName.lauric-acid": "Лауриновая кислота",
  "product.scheme.property.propertyName.myristic-acid": "Миристиновая кислота",
  "product.scheme.property.propertyName.pentadecanoic-acid": "Пентадекановая кислота",
  "product.scheme.property.propertyName.palmitic-acid": "Пальмитиновая кислота",
  "product.scheme.property.propertyName.margaric-acid": "Маргариновая кислота",
  "product.scheme.property.propertyName.stearic-acid": "Стеариновая кислота",
  "product.scheme.property.propertyName.arachidic-acid": "Арахиновая кислота",
  "product.scheme.property.propertyName.behenic-acid": "Бегеновая кислота",
  "product.scheme.property.propertyName.lignoceric-acid": "Лигноцериновая кислота",
  "product.scheme.property.propertyName.cerotic-acid": "Церотиновая кислота",
  "product.scheme.property.propertyName.riboflavin": "Рибофлавин",
  "product.scheme.property.propertyName.niacin": "Ниацин",
  "product.scheme.property.propertyName.pantothenic-acid": "Пантотеновая кислота",
  "product.scheme.property.propertyName.vitamin-b6": "Витамин-В6",
  "product.scheme.property.propertyName.biotin": "Биотин",
  "product.scheme.property.propertyName.protein": "Белки",
  "product.scheme.property.propertyName.linoleic-acid": "Линолевая кислота",
  "product.scheme.property.propertyName.alfa-linolenic-acid": "Альфа-линоленовая кислота",
  "product.scheme.property.propertyName.stearidonic-acid": "Стеаридоновая кислота",
  "product.scheme.property.propertyName.arachidonic-acid": "Арахидоновая кислота",
  "product.scheme.property.propertyName.timnodonic-acid": "Тимнодоновая кислота",
  "product.scheme.property.propertyName.clupanodonic-acid": "Клюпанодоническая кислота",
  "product.scheme.property.propertyName.cervonic-acid": "Цервонова кислота",
  "product.scheme.property.propertyName.ribose": "Рибоза",
  "product.scheme.property.propertyName.amylose": "Амилоза",
  "product.scheme.property.propertyName.amylopectin": "Амилопектин",
  "product.scheme.property.propertyName.B": "B",
  "product.scheme.property.propertyName.Ca": "Ca",
  "product.scheme.property.propertyName.Co": "Co",
  "product.scheme.property.propertyName.Cr": "Cr",
  "product.scheme.property.propertyName.Cu": "Cu",
  "product.scheme.property.propertyName.Fe": "Fe",
  "product.scheme.property.propertyName.I": "I",
  "product.scheme.property.propertyName.K": "K",
  "product.scheme.property.propertyName.Mg": "Mg",
  "product.scheme.property.propertyName.Mn": "Mn",
  "product.scheme.property.propertyName.Mo": "Mo",
  "product.scheme.property.propertyName.Na": "Na",
  "product.scheme.property.propertyName.P": "P",
  "product.scheme.property.propertyName.Se": "Se",
  "product.scheme.property.propertyName.Zn": "Zn",
  "product.scheme.property.propertyName.vitamin-a": "Витамин-А",
  "product.scheme.property.propertyName.thiamine": "Тиамин",
  "product.scheme.property.propertyName.folate": "Фолат",
  "product.scheme.property.propertyName.cobalamin": "Кобаламин",
  "product.scheme.property.propertyName.vitamin-c": "Витамин-C",
  "product.scheme.property.propertyName.vitamin-d": "Витамин-D",
  "product.scheme.property.propertyName.vitamin-e": "Витамин-E",
  "product.scheme.property.propertyName.vitamin-k": "Витамин-K",
  "product.scheme.property.propertyName.moisture": "Влага",
  "product.scheme.property.propertyName.fiber": "Волокна",
  "product.scheme.property.propertyName.alanine": "Аланин",
  "product.scheme.property.propertyName.agrinine": "Агринин",
  "product.scheme.property.propertyName.asparagine": "Аспарагин",
  "product.scheme.property.propertyName.cysteine": "Цистеин",
  "product.scheme.property.propertyName.glutamic-acid": "",
  "product.scheme.property.propertyName.glutamine": "Глютамин",
  "product.scheme.property.propertyName.glycine": "Глицин",
  "product.scheme.property.propertyName.histidine": "Гистидин",
  "product.scheme.property.propertyName.isoleucine": "Изолейцин",
  "product.scheme.property.propertyName.leucine": "Лейцин",
  "product.scheme.property.propertyName.lysine": "Лизин",
  "product.scheme.property.propertyName.methionine": "Метионин",
  "product.scheme.property.propertyName.phenylalanine": "Фенилаланин",
  "product.scheme.property.propertyName.proline": "Пролин",
  "product.scheme.property.propertyName.serine": "Серин",
  "product.scheme.property.propertyName.threonine": "Треонин",
  "product.scheme.property.propertyName.tryptophan": "Триптофан",
  "product.scheme.property.propertyName.tyrosine": "Тирозин",
  "product.scheme.property.propertyName.valine": "Валин",
  "product.scheme.property.propertyName.fat": "Жиры",
  "product.scheme.property.propertyName.starch": "Крахмал",
  "product.scheme.property.propertyName.saturated-fatty-acids": "Насыщенные жирные кислоты",
  "product.scheme.property.propertyName.monounsaturated-fatty-acids": "Мононенасыщенные жирные кислоты",
  "product.scheme.property.propertyName.myristol": "Миристол",
  "product.scheme.property.propertyName.pentadecenoic": "Пентадеценовый",
  "product.scheme.property.propertyName.palmitoyl": "Пальмитоил",
  "product.scheme.property.propertyName.heptadecenoic": "",
  "product.scheme.property.propertyName.oleic-acid": "Олеиновая кислота",
  "product.scheme.property.propertyName.eicosen": "Эйкозен",
  "product.scheme.property.propertyName.erucic-acid": "Эруковая кислота",
  "product.scheme.property.propertyName.nervonic-acid": "Нервная кислота",
  "product.scheme.property.propertyName.polyunsaturated-fatty-acids": "Полиненасыщенные жирные кислоты",
  "product.scheme.property.propertyName.carbohydrate": "Углеводы",
  "product.scheme.property.propertyName.total-sugars": "Общий сахар",
  "product.scheme.property.propertyName.glucose": "Глюкоза",
  "product.scheme.property.propertyName.sucrose": "Сахароза",
  "product.scheme.property.propertyName.maltose": "Мальтоза",
  "product.scheme.property.propertyName.galactose": "Галактоза",
  "product.scheme.property.propertyName.fructose": "Фруктоза",
  "product.scheme.property.propertyName.lactose": "Лактоза",
  "product.scheme.property.propertyName.antioxidant": "Антиоксидант",
  "product.scheme.property.propertyName.total-ash": "Общая зольность",
  "product.scheme.property.propertyName.minerals": "Минералы",
  "product.scheme.property.propertyName.carotene": "Каротины",
  "product.scheme.property.propertyName.choline": "Холин",
  "product.scheme.property.propertyName.energy": "Энергия",
  "product.scheme.property.propertyName.liquidKind": "Вид жидкости",
  "product.scheme.property.propertyName.black": "черный",
  "product.scheme.property.propertyName.yellow": "желтый",
  "product.scheme.property.propertyName.orange": "оранжевый",
  "product.scheme.property.propertyName.blue": "синий",
  "product.scheme.property.propertyName.red": "красный",
  "product.scheme.property.propertyName.green": "зеленый",
  "product.scheme.property.propertyName.white": "белый",
  "product.scheme.property.propertyName.purple": "фиолетовый",
  "product.scheme.property.propertyName.violet": "фиолетовый",
  "product.scheme.productCode.carrot": "морковь",
  "product.scheme.productCode.potato": "картофель",
  "product.scheme.productCode.apple": "яблоко",
  "product.scheme.productCode.orange": "апельсин",
  "product.scheme.productCode.tomato": "томат",
  "product.scheme.productCode.melon": "дыня",
  "product.scheme.productCode.watermelon": "арбуз",
  "product.scheme.productCode.cucumber": "огурец",
  "product.scheme.productCode.tomat": "помидор",
  "product.scheme.productCode.toast": "тост",
  "product.scheme.productCode.banana": "банан",
  "product.scheme.productCode.oat": "овес",
  "product.scheme.productCode.salmon": "лосось",
  "days.scheme.daysOfWeek.su": "вс",
  "days.scheme.daysOfWeek.mo": "пн",
  "days.scheme.daysOfWeek.tu": "вт",
  "days.scheme.daysOfWeek.we": "ср",
  "days.scheme.daysOfWeek.th": "чт",
  "days.scheme.daysOfWeek.sa": "сб",
  "days.scheme.months.January": "Январь",
  "days.scheme.months.February": "Февраль",
  "days.scheme.months.March": "Март",
  "days.scheme.months.April": "Апрель",
  "days.scheme.months.May": "Май",
  "days.scheme.months.June": "Июнь",
  "days.scheme.months.July": "Июль",
  "days.scheme.months.August": "Август",
  "days.scheme.months.September": "Сентябрь",
  "days.scheme.months.October": "Октябрь",
  "days.scheme.months.November": "Ноябрь",
  "days.scheme.months.December": "Декабрь",
  "product.item.code.almond": "Миндаль",
  "product.item.code.peanut": "арахис",
  "product.item.code.walnut": "Грецкий орех",
  "app.page.product.productUnitMcg": "мкг",
  "app.page.product.productUnitMcgTitle": "мкг (микрограмм)",
  "app.page.product.productUnitMg": "мг",
  "app.page.product.productUnitMgTitle": "мг (миллиграмм)",
  "app.page.product.productUnitG": "г",
  "app.page.product.productUnitGTitle": "г (грамм)",
  "app.page.onboarding.regenerate": "Рецепт можно перегенерировать",
  "app.page.onboarding.orChange": "или изменить",
  "app.page.onboarding.nutritionReport": "Отчет о питании покажет количество полезных веществ в рационе",
  "app.page.onboarding.eatingHabits": "Укажите ваши пищевые привычки:",
  "app.page.onboarding.chapcheCreate": "Chapche составит план питания, опираясь на ваши предпочтения в еде",
  "app.page.onboarding.title": "Добро пожаловать",
  "app.page.onboarding.to": "в",
  "app.page.onboarding.myPlan": "Мой план",
  "app.page.onboarding.preference": "Предпочтения",
  "app.page.onboarding.back": "Назад",
  "app.page.onboarding.continue": "Продолжить",
  "app.page.onboarding.finish": "Завершить",
  "app.page.product.updated": "Обновлено",
  "app.page.product.min": "мин",
  "app.page.product.hour": "ч",
  "app.page.product.ago": "назад",
  "product.item.code.carrot": "морковь",
  "product.item.code.potato": "картофель",
  "product.item.code.apple": "яблоко",
  "product.item.code.orange": "апельсин",
  "product.item.code.tomato": "помидор",
  "product.item.code.melon": "дыня",
  "product.item.code.watermelon": "арбуз",
  "product.item.code.cucumber": "огурец",
  "product.item.code.apricot": "Абрикос",
  "product.item.code.tomat": "томат",
  "product.item.code.toast": "тост",
  "product.item.code.banana": "банан",
  "product.item.code.oat": "овес",
  "product.item.code.salmon": "лосось",
  "product.scheme.form.code.any": "любая",
  "product.scheme.form.code.pulp": "мякоть",
  "product.scheme.form.code.with-skin": "с кожурой",
  "product.scheme.form.code.whole-grain": "цельнозерновой",
  "product.scheme.form.code.bran": "отруби",
  "product.scheme.form.code.tolokno": "толокно",
  "product.scheme.form.code.flour": "мука",
  "product.scheme.form.code.starch": "крахмал",
  "product.scheme.form.code.liquid": "жидкость",
  "product.scheme.form.code.raw": "сырой",
  "product.scheme.form.code.fry": "жареный",
  "product.scheme.form.code.without_skin": "без кожуры",
  "product.scheme.form.code.boiled": "вареный",
  "product.scheme.form.code.flesh": "плоть",
  "product.scheme.property.code.season": "Сезон",
  "product.scheme.property.code.pulp": "мякоть",
  "product.scheme.property.code.with_skin": "с кожурой",
  "product.scheme.property.code.without_skin": "без кожуры",
  "product.scheme.property.code.raw": "сырой",
  "product.scheme.property.code.boiled": "вареный",
  "product.scheme.property.code.from": "от",
  "product.scheme.property.code.to": "до",
  "product.scheme.property.code.vitamins": "Витамины",
  "product.scheme.property.code.vegetable": "Овощ",
  "product.scheme.property.code.fruit": "Фрукт",
  "product.scheme.property.code.berry": "Ягода",
  "product.scheme.property.code.salad": "Салат",
  "product.scheme.property.code.meat": "Мясо",
  "product.scheme.property.code.fish": "Рыба",
  "product.scheme.property.code.grain": "Зерно",
  "product.scheme.property.code.cereal": "Злак",
  "product.scheme.property.code.color": "Цвет",
  "product.scheme.property.code.aspartic-acid": "Аспарагиновая кислота",
  "product.scheme.property.code.butyric-acid": "Масляная кислота",
  "product.scheme.property.code.caproic-acid": "Капроновая кислота",
  "product.scheme.property.code.caprylic-acid": "Каприловая кислота",
  "product.scheme.property.code.capric-acid": "Каприновая кислота",
  "product.scheme.property.code.lauric-acid": "Лауриновая кислота",
  "product.scheme.property.code.myristic-acid": "Миристиновая кислота",
  "product.scheme.property.code.pentadecanoic-acid": "Пентадекановая кислота",
  "product.scheme.property.code.palmitic-acid": "Пальмитиновая кислота",
  "product.scheme.property.code.margaric-acid": "Маргариновая кислота",
  "product.scheme.property.code.stearic-acid": "Стеариновая кислота",
  "product.scheme.property.code.arachidic-acid": "Арахиновая кислота",
  "product.scheme.property.code.behenic-acid": "Бегеновая кислота",
  "product.scheme.property.code.lignoceric-acid": "Лигноцериновая кислота",
  "product.scheme.property.code.cerotic-acid": "Церотиновая кислота",
  "product.scheme.property.code.pantothenic-acid": "Пантотеновая кислота",
  "product.scheme.property.code.vitamin-b6": "Витамин-В6",
  "product.scheme.property.code.biotin": "Биотин",
  "product.scheme.property.code.protein": "Белки",
  "product.scheme.property.code.linoleic-acid": "Линолевая кислота",
  "product.scheme.property.code.alfa-linolenic-acid": "Альфа-линоленовая кислота",
  "product.scheme.property.code.stearidonic-acid": "Стеаридоновая кислота",
  "product.scheme.property.code.arachidonic-acid": "Арахидоновая кислота",
  "product.scheme.property.code.timnodonic-acid": "Тимнодоновая кислота",
  "product.scheme.property.code.clupanodonic-acid": "Клюпанодоническая кислота",
  "product.scheme.property.code.cervonic-acid": "Цервонова кислота",
  "product.scheme.property.code.ribose": "Рибоза",
  "product.scheme.property.code.amylose": "Амилоза",
  "product.scheme.property.code.amylopectin": "Амилопектин",
  "product.scheme.property.code.B": "B",
  "product.scheme.property.code.Ca": "Ca",
  "product.scheme.property.code.Co": "Co",
  "product.scheme.property.code.Cr": "Cr",
  "product.scheme.property.code.Cu": "Cu",
  "product.scheme.property.code.Fe": "Fe",
  "product.scheme.property.code.I": "I",
  "product.scheme.property.code.K": "K",
  "product.scheme.property.code.Mg": "Mg",
  "product.scheme.property.code.Mn": "Mn",
  "product.scheme.property.code.Mo": "Mo",
  "product.scheme.property.code.Na": "Na",
  "product.scheme.property.code.P": "P",
  "product.scheme.property.code.Se": "Se",
  "product.scheme.property.code.Zn": "Zn",
  "app.page.recipe.ingredientForm": "форма ингредиента",
  "product.scheme.property.code.folate": "Фолат",
  "product.scheme.property.code.cobalamin": "Кобаламин",
  "product.scheme.property.code.vitamin-c": "Витамин-C",
  "product.scheme.property.code.vitamin-d": "Витамин-D",
  "product.scheme.property.code.vitamin-k": "Витамин-K",
  "product.scheme.property.code.moisture": "Влага",
  "product.scheme.property.code.liquidKind": "Вид жидкости",
  "product.scheme.property.code.fiber": "Волокна",
  "product.scheme.property.code.alanine": "Аланин",
  "product.scheme.property.code.agrinine": "Агринин",
  "product.scheme.property.code.asparagine": "Аспарагин",
  "product.scheme.property.code.cysteine": "Цистеин",
  "product.scheme.property.code.glutamine": "Глютамин",
  "product.scheme.property.code.glycine": "Глицин",
  "product.scheme.property.code.histidine": "Гистидин",
  "product.scheme.property.code.isoleucine": "Изолейцин",
  "product.scheme.property.code.leucine": "Лейцин",
  "product.scheme.property.code.lysine": "Лизин",
  "product.scheme.property.code.methionine": "Метионин",
  "product.scheme.property.code.phenylalanine": "Фенилаланин",
  "product.scheme.property.code.proline": "Пролин",
  "product.scheme.property.code.serine": "Серин",
  "product.scheme.property.code.threonine": "Треонин",
  "product.scheme.property.code.tryptophan": "Триптофан",
  "product.scheme.property.code.tyrosine": "Тирозин",
  "product.scheme.property.code.valine": "Валин",
  "product.scheme.property.code.fat": "Жиры",
  "product.scheme.property.code.niacin": "Ниацин (Витамин РР)",
  "product.scheme.property.code.starch": "Крахмал",
  "product.scheme.property.code.saturated-fatty-acids": "Насыщенные жирные кислоты",
  "product.scheme.property.code.monounsaturated-fatty-acids": "Мононенасыщенные жирные кислоты",
  "product.scheme.property.code.myristol": "Миристол",
  "product.scheme.property.code.pentadecenoic": "Пентадеценовый",
  "product.scheme.property.code.palmitoyl": "Пальмитоил",
  "product.scheme.property.code.heptadecenoic": "",
  "product.scheme.property.code.oleic-acid": "Олеиновая кислота",
  "product.scheme.property.code.eicosen": "Эйкозен",
  "product.scheme.property.code.erucic-acid": "Эруковая кислота",
  "product.scheme.property.code.nervonic-acid": "Нервная кислота",
  "product.scheme.property.code.polyunsaturated-fatty-acids": "Полиненасыщенные жирные кислоты",
  "product.scheme.property.code.carbohydrate": "Углеводы",
  "product.scheme.property.code.total-sugars": "Общий сахар",
  "product.scheme.property.code.glucose": "Глюкоза",
  "product.scheme.property.code.sucrose": "Сахароза",
  "product.scheme.property.code.maltose": "Мальтоза",
  "product.scheme.property.code.galactose": "Галактоза",
  "product.scheme.property.code.fructose": "Фруктоза",
  "product.scheme.property.code.lactose": "Лактоза",
  "product.scheme.property.code.antioxidant": "Антиоксидант",
  "product.scheme.property.code.vitamin-e": "Витамин E",
  "app.page.preference.filters": "фильтры",
  "product.scheme.property.code.minerals": "Минералы",
  "product.scheme.property.code.carotene": "Каротины",
  "product.scheme.property.code.choline": "Холин",
  "product.scheme.property.code.energy": "Энергия",
  "product.scheme.property.code.black": "черный",
  "product.scheme.property.code.yellow": "желтый",
  "product.scheme.property.code.orange": "оранжевый",
  "product.scheme.property.code.blue": "синий",
  "product.scheme.property.code.red": "красный",
  "product.scheme.property.code.green": "зеленый",
  "product.scheme.property.code.white": "белый",
  "product.scheme.property.code.purple": "фиолетовый",
  "product.scheme.property.code.violet": "фиолетовый",
  "recipe.item.type.snack": "снэк",
  "recipe.item.type.smoothies": "смузи",
  "recipe.item.type.granola": "гранола",
  "recipe.item.type.bread": "хлеб",
  "recipe.item.type.kasha": "каша",
  "recipe.item.type.bowl": "боул",
  "recipe.item.type.soup": "суп",
  "app.page.appRole.businessObjectAndRoles.locale": "локаль",
  "app.page.product.excludeForm": "Исключить форму",
  "app.page.product.formException": "Исключение формы",
  "app.page.product.cancel": "отмена",
  "app.page.product.exclude": "исключить",
  "app.page.appRole.businessObjectAndRoles.app_role": "роли",
  "app.page.product.modal.createProduct.title": "создайте код продукта",
  "app.page.product.modal.createProduct.content": "созданный код не подлежит изменению",
  "app.page.product.modal.createProduct.cancel": "отмена",
  "app.page.product.modal.createProduct.create": "создать",
  "app.page.recipe.modal.createRecipe.title": "выберите тип рецепта",
  "app.page.recipe.modal.createRecipe.content": "его можно будет изменить в любое время",
  "app.page.recipe.modal.createRecipe.cancel": "отмена",
  "app.page.recipe.modal.createRecipe.create": "создать",
  "app.page.recipe.recipeType": "тип рецепта",
  "app.page.recipe.modal.deleteModal.title": "удаление ингредиента",
  "app.page.recipe.modal.deleteModal.content": "вы хотите удалить ингредиент",
  "app.page.recipe.modal.addModal.title": "добавьте продукт",
  "app.page.recipe.modal.addModal.add": "продолжить",
  "app.page.recipe.needToFillIngredientForm": "обязательное поле",
  "app.page.product.propertySearch": "поиск свойства",
  "app.page.product.productFormTab.addProperty": "добавить свойство",
  "app.page.product.productFormTab.searchProperties": "поиск свойств",
  "app.page.product.productAddProperty.title": "Введите название свойства",
  "app.page.product.productAddProperty.continue": "продолжить",
  "app.page.product.productAddProperty.cancel": "отмена",
  "product.scheme.property.categoryName.micronutrient": "микронутриенты",
  "product.scheme.property.categoryName.macronutrient": "макронутриенты",
  "product.scheme.property.categoryName.physical": "физические свойства",
  "product.scheme.property.categoryName.vitamin": "витамины",
  "product.scheme.property.propertyType.number": "числовое значение",
  "app.page.product.notFound": "ничего не найдено",
  "app.page.preference.showPreference": "показать предпочтения",
  "app.page.preference.clearAll": "очистить всё",
  "product.scheme.formGroup.oil-seeds": "масличные семена",
  "app.page.preference.group": "группы",
  "product.scheme.form.code.dried-fruit": "сушеный",
  "app.page.product.hint": "продукт используется в рецепте или пропорциях",
  "product.item.code.apricot-dried": "Абрикос сушеный",
  "app.page.preference.meal": "приемы пищи",
  "app.page.preference.phrase": "фразы",
  "app.page.product.edit": "изменить продукт",
  "app.page.form.title": "формы",
  "app.page.form.edit": "изменить форму",
  "app.page.form.new": "добавить форму",
  "app.page.property.title": "свойства",
  "app.page.property.edit": "изменить свойство",
  "app.page.property.new": "добавить свойство",
  "app.page.property.composition.openTree": "дерево состава макро",
  "app.page.property.composition.backToList": "к списку свойств",
  "app.page.property.composition.title": "состав белков, жиров и углеводов",
  "app.page.property.composition.hint": "только просмотр связей; клик по свойству открывает карточку. рёбра из metadata, не редактируются здесь",
  "app.page.property.composition.loading": "загрузка…",
  "app.page.property.composition.emptyBranch": "нет засеянных частей",
  "app.page.property.composition.missingRoot": "корневое свойство отсутствует в каталоге",
  "app.page.property.composition.root.protein": "белки",
  "app.page.property.composition.root.fat": "жиры",
  "app.page.property.composition.root.carbohydrate": "углеводы",
  "app.page.property.composition.group.proteinAggregates": "агрегаты / фракции",
  "app.page.property.composition.group.aminoAcids": "аминокислоты",
  "app.page.property.composition.group.otherProtein": "прочие части белка",
  "app.page.property.composition.group.fatSubtotals": "суммы ЖК",
  "app.page.property.composition.group.fattyAcids": "жирные кислоты",
  "app.page.property.composition.group.saturated-fatty-acids": "насыщенные ЖК",
  "app.page.property.composition.group.monounsaturated-fatty-acids": "мононенасыщенные ЖК",
  "app.page.property.composition.group.polyunsaturated-fatty-acids": "полиненасыщенные ЖК",
  "app.page.property.composition.group.sugars": "сахара",
  "app.page.property.composition.group.starch": "крахмал",
  "app.page.property.composition.group.fiber": "клетчатка",
  "app.page.property.composition.group.otherCarb": "прочие углеводы",
  "app.page.property.composition.badge.essential": "незаменимая",
  "app.page.property.composition.badge.non-essential": "заменимая",
  "app.page.property.composition.badge.conditionally-essential": "условно незаменимая",
  "app.page.property.composition.badge.conditionally-non-essential": "условно заменимая",
  "app.page.property.composition.badge.efa": "незаменимая ЖК",
  "app.page.property.composition.badge.saturated": "насыщенные",
  "app.page.property.composition.badge.unsaturated": "ненасыщенные",
  "app.page.property.composition.badge.monounsaturated": "мононенасыщенные",
  "app.page.property.composition.badge.polyunsaturated": "полиненасыщенные",
  "app.page.property.composition.badge.trans-fats": "трансжиры",
  "app.page.property.composition.badge.monosaccharide": "моносахарид",
  "app.page.property.composition.badge.mono-and-disaccharide": "моно- и дисахариды",
  "app.page.property.composition.badge.disaccharide": "дисахарид",
  "app.page.property.composition.badge.di-and-polysaccharide": "ди- и полисахариды",
  "app.page.property.composition.badge.polysaccharide": "полисахарид",
  "app.page.cookingStep.title": "шаги приготовления",
  "app.page.cookingStep.edit": "изменить шаги",
  "app.page.cookingStep.new": "добавить шаг",
  "app.page.cookingStep.addStep": "добавить шаг",
  "app.page.cookingStep.empty": "шагов пока нет",
  "app.page.cookingStep.emptyForType": "Пока нет шагов для «{{type}}»",
  "app.page.cookingStep.addFirstStep": "добавить первый шаг",
  "app.page.cookingStep.selectStep": "выберите шаг слева",
  "app.page.cookingStep.stepsCount": "шаги ({{count}})",
  "app.page.cookingStep.detailTitle": "шаг · {{code}}",
  "app.page.cookingStep.stepCode": "Код шага",
  "app.page.cookingStep.stepCodeHint": "Технический идентификатор латиницей, например rinse-grain. Нужен системе, пользователь его не видит.",
  "app.page.cookingStep.stepOrder": "порядок",
  "app.page.cookingStep.section.instruction": "Инструкция",
  "app.page.cookingStep.section.meta": "Служебное",
  "app.page.cookingStep.section.reminder": "Напоминание",
  "app.page.cookingStep.textLocale.ru": "RU",
  "app.page.cookingStep.textLocale.en": "EN",
  "app.page.cookingStep.textForUser.ru": "Текст для пользователя (RU)",
  "app.page.cookingStep.textForUser.en": "Текст для пользователя (EN)",
  "app.page.cookingStep.badge.reminder": "напоминание",
  "app.page.cookingStep.badge.conditions": "{{count}} усл.",
  "app.page.cookingStep.badge.always": "всегда",
  "app.page.cookingStep.dragHandle": "перетащить шаг",
  "app.page.cookingStep.saveStatus.saving": "сохраняем…",
  "app.page.cookingStep.saveStatus.saved": "сохранено",
  "app.page.cookingStep.saveStatus.savedAt": "сохранено {{time}}",
  "app.page.cookingStep.saveStatus.error": "не удалось сохранить",
  "app.page.cookingStep.saveStatus.retry": "повторить",
  "app.page.cookingStep.textRu": "Текст для пользователя (RU)",
  "app.page.cookingStep.textEn": "Текст для пользователя (EN)",
  "app.page.cookingStep.isReminder": "Это напоминание заранее",
  "app.page.cookingStep.reminderKindLabel": "Когда напомнить",
  "app.page.cookingStep.reminderKind.preset": "по пресету",
  "app.page.cookingStep.reminderKind.offset_hours": "за N часов до приёма",
  "app.page.cookingStep.reminderPresetLabel": "Пресет",
  "app.page.cookingStep.reminderPreset.evening_before": "Вечером накануне",
  "app.page.cookingStep.reminderPreset.morning_of": "Утром в день приёма",
  "app.page.cookingStep.reminderOffsetHours": "За сколько часов до приёма",
  "app.page.cookingStep.conditions": "Когда показывать шаг",
  "app.page.cookingStep.conditionsAlways": "Шаг показывается всегда",
  "app.page.cookingStep.conditionsAndHint": "Шаг покажется, только если выполнены все условия.",
  "app.page.cookingStep.conditionTypeLabel": "Когда",
  "app.page.cookingStep.conditionType.product_field": "По свойству продукта",
  "app.page.cookingStep.conditionType.product_code": "Если в блюде есть продукт",
  "app.page.cookingStep.conditionType.any_ingredient_group_present": "Если есть группа ингредиентов",
  "app.page.cookingStep.conditionType.kasha_consistency": "Если консистенция каши равна",
  "app.page.cookingStep.conditionType.kasha_consistency_in": "Если консистенция каши одна из",
  "app.page.cookingStep.kashaConsistencyChipsLabel": "Консистенция",
  "app.page.cookingStep.preview.kashaConsistency": "консистенция каши — {{value}}",
  "app.page.cookingStep.preview.kashaConsistencyIn": "консистенция каши одна из: {{values}}",
  "app.page.cookingStep.ingredientGroupLabel": "Группа",
  "app.page.cookingStep.ingredientGroup.base": "Основа",
  "app.page.cookingStep.ingredientGroup.adds": "Добавки",
  "app.page.cookingStep.ingredientGroup.tasty": "Вкус",
  "app.page.cookingStep.ingredientGroup.liquid": "Жидкость",
  "app.page.cookingStep.fieldName": "Свойство",
  "app.page.cookingStep.fieldNameCustom": "Своё свойство (snake_case)",
  "app.page.cookingStep.operator": "Оператор",
  "app.page.cookingStep.value": "Значение",
  "app.page.cookingStep.productCode": "Код продукта",
  "app.page.cookingStep.productCodePlaceholder": "Начните вводить код или название…",
  "app.page.cookingStep.productField.before_cooking_rinse_need": "Нужно промыть перед готовкой",
  "app.page.cookingStep.productField.other": "Другое…",
  "app.page.cookingStep.bool.yes": "Да",
  "app.page.cookingStep.bool.no": "Нет",
  "app.page.cookingStep.groupsChipsLabel": "Группы в блюде",
  "app.page.cookingStep.preview.productField": "если у {{group}} «{{property}}» = {{value}}",
  "app.page.cookingStep.preview.productCode": "если в блюде есть «{{product}}»",
  "app.page.cookingStep.preview.groupsPresent": "если в блюде есть {{groups}}",
  "app.page.cookingStep.preview.unknown": "условие",
  "app.page.cookingStep.preview.always": "всегда",
  "app.page.cookingStep.preview.and": "и",
  "app.page.cookingStep.validation.required": "Обязательное поле",
  "app.page.cookingStep.validation.noPlaceholders": "В тексте нельзя использовать {{placeholders}} — выберите блок пропорции",
  "app.page.cookingStep.validation.stepHasErrors": "В шаге есть незаполненные поля",
  "app.page.cookingStep.measureBlockLabel": "Блок пропорции",
  "app.page.cookingStep.measureBlockHint": "Системная фраза с объёмами и отношением 1∶N подставится при генерации каши. В textarea только опциональная проза без чисел.",
  "app.page.cookingStep.measureBlock.none": "нет",
  "app.page.cookingStep.measureBlock.grain": "крупа",
  "app.page.cookingStep.measureBlock.liquid": "жидкость",
  "app.page.cookingStep.measureBlock.both": "оба",
  "app.page.cookingStep.addCondition": "Добавить условие",
  "app.page.cookingStep.addConditionFirst": "Ограничить условиями",
  "app.page.cookingStep.removeCondition": "Удалить",
  "app.page.cookingStep.modal.cancel": "отмена",
  "app.page.cookingStep.modal.create.title": "добавить шаг приготовления",
  "app.page.cookingStep.modal.create.create": "создать",
  "app.page.cookingStep.modal.delete.title": "удалить шаг",
  "app.page.cookingStep.modal.delete.content": "вы уверены, что хотите удалить этот шаг приготовления?",
  "app.page.cookingStep.modal.delete.delete": "удалить",
  "app.page.preference.edit": "изменить предпочтение",
  "app.page.preference.new": "добавить предпочтение",
  "app.page.recipe.edit": "изменить рецепт",
  "app.page.recipe.new": "добавить рецепт",
  "app.page.product.propertyItem.vitamin": "витамин",
  "app.page.product.propertyItem.type": "вид",
  "app.page.product.propertyItem.waterSoluble": "водорастворимый",
  "app.page.product.propertyItem.fatSoluble": "жирорастворимый",
  "product.scheme.property.vitamin.waterSoluble": "витамин водораствор.",
  "product.scheme.property.vitamin.fatSoluble": "витамин жирораствор.",
  "app.page.preference.addGroup": "добавить группу",
  "app.page.group.title": "группы",
  "app.page.group.new": "добавить группу",
  "app.page.group.edit": "изменить группу",
  "app.page.product.applyTo": "применить к...",
  "app.page.product.fillAs": "заполнить как...",
  "app.page.product.modal.updateProperties.title": "применение свойства",
  "app.page.product.modal.updateProperties.meaning": "значение",
  "app.page.product.modal.updateProperties.applyTo": "применить к",
  "app.page.product.checkProductError": "код продукта может состоять из латиницы, цифр и знаков “-” и “_”",
  "public.email.forgotten.subtitleInfo": "",
  "public.email.forgotten.buttonText": "Изменить пароль",
  "public.email.forgotten.downloadPlan": "Получить план",
  "product.scheme.form.code.dried-nut": "Сушеный",
  "product.item.code.sunflower-seeds": "Семена подсолнечника",
  "product.item.code.pumpkin-seeds": "Тыквенные семечки",
  "product.scheme.form.code.dried-berry": "Сушеный",
  "product.item.code.grape-raw": "Виноград",
  "product.item.code.grape-dried": "Виноград сушеный",
  "app.page.product.modal.updateProperties.cancel": "отмена",
  "app.page.product.modal.updateProperties.save": "сохранить",
  "app.page.product.modal.updateProperties.allForms": "все формы продукта",
  "app.page.product.modal.updateProperties.allProperties": "все свойства продукта",
  "app.page.preference.addTitles.howOften": "как часто?",
  "preference.scheme.frequency.no-matter": "не имеет значения",
  "preference.scheme.frequency.everyDay": "каждый день",
  "preference.scheme.frequency.dayAfterDay": "через день",
  "preference.scheme.frequency.onceInDays": "раз в",
  "preference.scheme.preferenceType.cereal-mix": "зерновая смесь",
  "app.page.product.notAssigned": "не назначено",
  "app.page.preference.groupName": "название группы",
  "app.page.property.hint": "используется в продукте",
  "app.page.form.hint": "используется в продукте или свойстве",
  "app.page.product.checkFormError": "код формы может состоять из латиницы, цифр и знаков “-” и “_”",
  "app.page.product.checkPropertyError": "код свойства может состоять из латиницы, цифр и знаков “-” и “_”",
  "app.page.product.modal.createForm.title": "создайте код формы",
  "app.page.product.modal.createProperty.title": "создайте код свойства",
  "app.page.product.modal.createForm.content": "созданный код не подлежит изменению ",
  "app.page.product.modal.createProperty.content": "созданный код не подлежит изменению ",
  "app.page.property.vitaminError": "выберите вид",
  "app.page.product.modal.cancel": "отмена",
  "app.page.product.modal.create": "создать",
  "app.page.preference.daysCount": "количество дней",
  "app.page.product.filters.yellow": "желтый",
  "app.page.product.filters.red": "красный",
  "app.page.product.filters.green": "зеленый",
  "app.page.product.filters.black": "черный",
  "app.page.product.filters.white": "белый",
  "app.page.product.filters.vegetable": "овощ",
  "app.page.product.filters.fruit": "фрукт",
  "app.page.product.filters.berry": "ягода",
  "app.page.product.filters.meat": "мясо",
  "app.page.product.filters.fish": "рыба",
  "app.page.product.filters.formGroup": "группа формы",
  "app.page.product.filters.formType": "тип формы",
  "app.page.form.filters.grain": "зерно",
  "app.page.form.filters.vegetable": "овощ",
  "app.page.form.filters.meat": "мясо",
  "app.page.form.filters.any": "любая",
  "app.page.form.filters.heatTreatment": "тепловая обработка",
  "app.page.form.filters.product-part": "часть продукта",
  "app.page.product.filters.propertyType": "тип свойства",
  "app.page.property.filters.number": "числовое значение",
  "app.page.property.filters.select": "выбор значения",
  "app.page.property.filters.boolean": "булевое значение",
  "app.page.property.filters.string": "строка",
  "app.page.product.filters.categoryName": "категория",
  "app.page.property.filters.macronutrients": "макронутриенты",
  "app.page.property.filters.micronutrients": "микронутриенты",
  "app.page.property.filters.physical": "физические свойства",
  "app.page.product.filters.vitamin": "витамин",
  "app.page.property.filters.notVitamin": "не витамин",
  "app.page.property.filters.fatSoluble": "жирорастворимый",
  "app.page.property.filters.waterSoluble": "водорастворимый",
  "app.page.product.filters.ingredient": "ингредиент",
  "app.page.product.filters.include": "Хочу/Не хочу",
  "app.page.preferences.filters.true": "да",
  "app.page.preferences.filters.false": "нет",
  "app.page.product.filters.preferenceType": "что хочу",
  "app.page.product.filters.group": "группа предпочтений",
  "app.page.product.filters.when": "когда",
  "app.page.product.filters.isInternal": "внутренний",
  "app.page.product.showDeleted": "показать удаленные",
  "app.page.product.filters.clean": "очистить",
  "preference.scheme.when.no-matter": "не важно",
  "preference.scheme.groups.base": "базовая",
  "preference.scheme.groups.season": "сезонная",
  "preference.scheme.groups.collection": "избранное",
  "preference.scheme.groups.noGroup": "без группы",
  "app.page.product.checkCodeExists": "такой код уже существует",
  "app.page.product.checkCodeDeleted": "код принадлежит удаленному продукту – придумайте другой код",
  "app.page.preference.newPreference": "новое предпочтение",
  "app.page.preference.preferenceAsPhrase": "предпочтение в виде фразы",
  "app.page.preference.preferenceAsPhrasePlaceholder": "мне нравится есть кашу по утрам",
  "app.page.preference.preferenceAsPhraseInfo": "после ввода «Предпочтение в виде фразы», «Предпочтение в виде таблицы» заполнится автоматически",
  "app.page.preference.preferenceAsTable": "предпочтение в виде таблицы",
  "app.page.preference.preferenceAsTablePlaceholder": "введите или выберите из списка",
  "app.page.preference.preferenceActivityPeriod": "предпочтение действует только в определенный день",
  "app.page.preference.preferenceAsTableInfo": "после ввода «Предпочтение в виде таблицы», «Предпочтение в виде фразы» заполнится автоматически",
  "app.page.preference.modal.create": "создать",
  "preference.scheme.frequency.onceInWeek": "раз в неделю",
  "preference.scheme.frequency.onceInDay": "раз в день",
  "preference.scheme.frequency.onceInTwoDays": "раз в 2 дня",
  "preference.scheme.frequency.onceInThreeDays": "раз в 3 дня",
  "preference.scheme.frequency.onceInFourDays": "раз в 4 дня",
  "preference.scheme.frequency.onceInFiveDays": "раз в 5 дней",
  "app.page.preference.oftenSelect": "часто выбирают",
  "app.page.preference.notFound": "ничего не нашлось",
  "app.page.preference.notFoundCode": "такого у нас пока нет",
  "app.page.preference.myPreferences": "мои предпочтения",
  "app.page.preference.createPreference": "создать предпочтение",
  "app.page.preference.until": "до",
  "app.page.preference.always": "всегда",
  "app.page.preference.morning": "утром",
  "app.page.preference.brunch": "на бранч",
  "app.page.preference.lunch": "на обед",
  "app.page.preference.afternoon": "на полдник",
  "app.page.preference.dinner": "на ужин",
  "app.page.preference.night": "на ночь",
  "app.page.preference.no-matter": "не важно",
  "app.page.product.restore.modal.item.title": "восстановление продукта",
  "app.page.product.restore.modal.form.title": "восстановление формы",
  "app.page.product.restore.modal.property.title": "восстановление свойства",
  "app.page.product.restore.modal.item.content": "вы хотите восстановить продукт",
  "app.page.product.restore.modal.form.content": "вы хотите восстановить форму",
  "app.page.product.restore.modal.property.content": "вы хотите восстановить свойство",
  "app.page.product.modal.restore": "восстановить",
  "app.page.item.hint": "продукт используется в рецепте или пропорциях",
  "app.page.product.modal.item.forceDelete.content": "вы хотите навсегда удалить продукт",
  "app.page.product.modal.form.forceDelete.content": "вы хотите навсегда удалить форму",
  "app.page.product.modal.property.forceDelete.content": "вы хотите навсегда удалить свойство",
  "product.scheme.property.code.valueOfData": "значение",
  "app.page.product.form.checkCodeDeleted": "код принадлежит удаленной форме – придумайте другой код",
  "app.page.product.property.checkCodeDeleted": "код принадлежит удаленному свойству – придумайте другой код",
  "app.page.preference.addCerealMix": "добавить свою смесь",
  "app.page.product.property.userPropertyType": "свойство отображается в кабинете пользователя как:",
  "app.page.product.property.vitaminMineral": "витамин (минерал)",
  "app.page.product.property.calories": "блюдо по калорийности",
  "app.page.product.property.pfcPriority": "приоритет БЖУ",
  "app.page.product.property.colorDiet": "цветовая диета",
  "product.scheme.property.code.organic-acids": "Органические кислоты",
  "product.scheme.form.code.flakes": "хлопья",
  "product.scheme.property.code.cholesterol": "холестерин",
  "product.scheme.property.code.mono-and-disaccharides": "Моно- и дисахариды",
  "product.scheme.property.code.total-ash": "Общая зольность (зола)",
  "product.scheme.property.code.alimentary-fiber": "Пищевые волокна",
  "product.scheme.property.code.na": "Натрий",
  "product.scheme.property.code.k": "Калий",
  "product.scheme.property.code.ca": "Кальций",
  "product.scheme.property.code.mg": "Магний",
  "product.scheme.property.code.p": "фосфор",
  "product.scheme.property.code.fe": "железо",
  "product.scheme.property.code.beta-carotene": "бета-каротин",
  "product.scheme.property.code.retinol-equivalent": "Эквивалент ретинола",
  "product.scheme.property.code.tocopherol-equivalent": "Эквивалент токоферола",
  "product.scheme.property.code.pp": "ниацин",
  "product.scheme.property.code.niacin-equivalent": "Ниациновый эквивалент",
  "product.scheme.property.code.a": "ретинол, Витамин А",
  "product.scheme.property.code.c": "Аскорбиновая кислота",
  "product.scheme.form.code.cereal": "Крупа",
  "product.item.code.fig": "Инжир",
  "product.item.code.wheat": "Пшеница",
  "product.item.code.flower-honey": "Цветочный мед",
  "product.item.code.rye": "рожь",
  "product.item.code.fig-dried": "Инжир сушеный",
  "product.item.code.rice": "рис",
  "product.item.code.kiwi": "Киви",
  "product.item.code.buckwheat": "гречиха",
  "product.item.code.blueberry": "Голубика",
  "product.item.code.barley": "ячмень (перловка)",
  "app.page.preference.groups.isAutoAssigned": "предпочтения из этой группы будут назначены пользователю при регистрации",
  "app.page.preference.groups.always": "всегда",
  "app.page.preference.groups.activityPeriods": "выбранный период",
  "app.page.preference.groups.activityRange": "диапазон активности",
  "app.page.preference.groups.from": "с",
  "app.page.preference.groups.to": "по",
  "app.page.preference.groups.placeholder": "дд.мм.",
  "product.item.code.strawberry": "Клубника",
  "app.page.preference.addTitles.preferenceItemCode": "что именно?",
  "app.page.preference.addTitles.color": "цвет",
  "public.app.page.login.registrationPhrase": "регистрация по запросу",
  "app.page.preference.preferenceAssignGroup": "назначение группы",
  "app.page.preference.groupItemName": "имя группы",
  "app.page.preference.showIsWelcome": "показать исходный набор фраз",
  "product.item.code.wheat-cereal": "Пшеница крупа",
  "app.page.preference.downloadCSV": "скачать CSV файл",
  "product.item.code.rye-whole-grain": "Ржаная крупа",
  "app.page.product.productUnitKcalTitle": "ккал",
  "app.page.product.productUnitFullMcg": "мкг/100 г",
  "app.page.product.propertyItem.numberUnits": "единицы измерения",
  "app.page.recipe.modal.addIngredient.title": "добавление ингредиента",
  "app.page.recipe.modal.addIngredient.selectType": "выберите тип ингредиента",
  "app.page.preference.noPhrases": "нет фраз",
  "app.page.product.filters.activityPeriod": "диапазон активности",
  "app.page.product.filters.isAutoAssigned": "назначены при регистрации",
  "product.item.code.rye-flour": "Ржаная мука",
  "product.item.code.turkey-soy-broth": "бульон из индейки с соевой пастой",
  "preference.scheme.groups.placeholder": "поиск группы",
  "app.page.preference.groups.modal.title": "удаление группы",
  "app.page.preference.groups.modal.content": "вы хотите удалить группу",
  "app.page.preference.enterPhrase": "введите фразу",
  "app.page.product.warningLocaleHint": "не заполнен перевод названия",
  "app.page.listView.tile": "плитка",
  "app.page.listView.table": "таблица",
  "app.page.listView.ariaLabel": "вид списка",
  "app.page.listView.tableUnavailable": "таблица доступна на планшете и шире",
  "app.page.listView.empty": "ничего не найдено",
  "app.page.listView.deleted": "удалён",
  "app.page.listView.name": "название",
  "app.page.listView.code": "код",
  "app.page.listView.status": "статус",
  "app.page.listView.actions": "действия",
  "app.page.listView.type": "тип",
  "app.page.product.filters.status": "статус",
  "product.scheme.filter.isNotValid": "невалидные",
  "product.scheme.filter.isDeleted": "удаленные",
  "app.page.preference.addInIsWelcome": "добавить в исходный набор",
  "product.scheme.formGroup.nut": "орех",
  "product.scheme.formGroup.berry": "ягода",
  "app.page.preference.phrasesForPreference": "фразы к предпочтению",
  "app.page.preference.generated": "сгенерированы",
  "app.page.product.productCategory": "категория продукта",
  "app.page.product.filters.productCategory": "категория продукта",
  "app.page.preference.modal.deletePhrase": "удаление фразы",
  "app.page.preference.modal.deletePhraseAgree": "вы хотите удалить выбранную фразу?",
  "product.scheme.formGroup.fruit": "фрукт",
  "product.scheme.formGroup.fish": "рыба",
  "product.scheme.formGroup.poultry": "птица",
  "product.scheme.formGroup.any": "любая",
  "product.scheme.property.code.sodium": "натрий",
  "app.page.appRole.businessObjectAndRoles.recipe_scheme": "схема рецепта",
  "app.page.appRole.businessObjectAndRoles.preference_scheme": "схема предпочтения",
  "product.scheme.formGroup.honey": "мёд",
  "product.scheme.property.code.vitamin-a": "ретинол",
  "product.scheme.property.code.ferrum": "железо",
  "product.scheme.property.code.phosphorus": "Фосфор",
  "product.scheme.property.code.magnesium": "Магний",
  "product.scheme.property.code.calcium": "Кальций",
  "product.scheme.property.code.potassium": "калий",
  "public.app.page.login.passwordValidation": "пароль должен содержать буквы, цифры и спец. символы",
  "product.scheme.property.code.glutamic-acid": "Глютаминовая кислота",
  "product.scheme.form.code.sliced-vegetable": "Резаный",
  "app.page.preference.mainPreference": "укажите свои предпочтения в еде",
  "product.scheme.property.code.ascorbic-acid": "Аскорбиновая кислота (Витамин С)",
  "app.page.preference.phrasesGenerateFail": "заполните недостающую фразу к предпочтению пользователя",
  "product.scheme.form.code.puree-vegetable": "Пюре",
  "app.page.preference.preferenceGenerateFail": "заполните недостающие поля к предпочтению пользователя",
  "product.item.code.wheat-whole-grain": "пшеница цельнозерновая",
  "product.scheme.property.code.arginine": "Аргинин",
  "product.scheme.property.code.albumins": "Альбумины",
  "product.scheme.property.code.globulins": "Глобулины",
  "product.scheme.property.code.cystine": "Цистин",
  "product.scheme.property.code.albumins-and-globulins": "Альбумины и глобулины",
  "product.scheme.property.code.amino-acid": "Аминокислоты",
  "product.scheme.property.code.manganese": "Марганец",
  "product.scheme.property.code.lecithin": "лецитин",
  "product.scheme.property.code.cuprum": "Медь",
  "product.scheme.property.code.unsaturated-fatty-acids": "Ненасыщенные жирные кислоты",
  "product.scheme.property.code.folic-acid": "Фолиевая кислота",
  "product.scheme.property.code.linolenic-acid": "Линоленовая кислота",
  "product.scheme.property.code.silicon": "Кремний",
  "product.scheme.property.code.sulfur": "Сера",
  "product.item.code.quinoa": "Киноа",
  "product.scheme.property.code.aluminum": "Алюминий",
  "product.scheme.property.code.zinc": "Цинк",
  "product.scheme.property.code.sugar": "Сахар",
  "product.scheme.property.code.cellulose": "Клетчатка",
  "product.scheme.property.code.pyridoxine": "Пиридоксин",
  "product.scheme.property.code.selenium": "Селен",
  "app.page.product.basedOn": "за основу взять",
  "app.page.phrase.title": "фразы",
  "app.page.phrase.edit": "изменить фразу",
  "product.item.code.amaranth": "Амарант",
  "product.scheme.form.code.flakes-small-flattened": "хлопья малого плющения",
  "product.scheme.property.code.mono-and-polyunsaturated-fatty-acids": "Моно и полиненасыщенные жирные кислоты",
  "product.item.code.quinoa-boiled": "Киноа вареное",
  "product.scheme.form.code.sliced": "Резаный",
  "product.scheme.form.code.mash": "Размятый",
  "product.scheme.form.code.puree": "Пюре",
  "product.scheme.form.code.whole": "Целый",
  "product.scheme.property.code.nitrogen": "Азот",
  "public.app.page.login.passwordsIsNotEqual": "пароли не совпадают",
  "product.scheme.form.code.whole-vegetable": "Целый",
  "product.scheme.form.code.whole-berry": "Целый",
  "product.scheme.form.code.mash-vegetable": "Размятый",
  "product.scheme.form.code.whole-fruit": "Целый",
  "product.scheme.form.code.sliced-fruit": "резаный",
  "product.scheme.form.code.sliced-berry": "резаный",
  "product.scheme.form.code.mash-fruit": "размятый",
  "product.scheme.form.code.puree-fruit": "пюре",
  "product.scheme.form.code.mash-berry": "размятый",
  "product.scheme.form.code.puree-berry": "Пюре",
  "product.scheme.formGroup.dairy": "молочные продукты",
  "product.scheme.formGroup.legumes": "бобовые",
  "product.scheme.formGroup.salad-green": "зелень",
  "product.scheme.formGroup.egg": "яйцо",
  "product.scheme.formGroup.cheese": "сыр",
  "product.scheme.formGroup.pasta": "макароны",
  "product.scheme.formGroup.oil": "масла",
  "product.scheme.formGroup.spices": "специи",
  "product.scheme.formGroup.sauce": "соус",
  "product.scheme.formGroup.vinegar": "уксус",
  "public.app.page.login.title": "войти",
  "public.app.page.login.email": "email",
  "public.app.page.login.password": "пароль",
  "public.app.page.login.continue": "продолжить",
  "public.app.page.login.passwordCreating": "создание пароля",
  "public.app.page.login.repeatPassword": "повторите пароль",
  "public.app.page.login.passwordError": "Введен неверный пароль",
  "public.app.page.login.signInError": "Неверный логин или пароль",
  "public.app.page.login.exit": "выход",
  "public.app.page.login.sendCode": "Мы отправили СМС с кодом на ваш номер",
  "public.app.page.login.code": "Код из СМС",
  "public.app.page.login.askAgain": "Запросить код повторно через",
  "public.app.page.login.sendAgain": "Выслать повторно",
  "public.app.page.login.dontReceive": "Не приходит СМС",
  "public.app.page.login.phone": "Номер телефона",
  "public.app.page.login.or": "или",
  "public.app.page.login.signIn": "Войти",
  "public.app.page.login.signUp": "Регистрация",
  "public.app.page.login.exitCabinet": "Выйти",
  "public.app.page.login.data": "мои данные",
  "public.app.page.login.yourName": "ваше имя",
  "public.app.page.login.signUpButton": "зарегистрироваться",
  "public.app.page.login.modal.title": "Выход из аккаунта",
  "public.app.page.login.modal.content": "Вы уверены, что хотите выйти?",
  "public.app.page.login.modal.exit": "выйти",
  "public.app.page.login.modal.cancel": "отменить",
  "public.app.page.login.show": "показать",
  "public.app.page.login.hide": "скрыть",
  "public.app.page.login.capsLock": "Включен Caps Lock",
  "public.app.page.login.content": "На данный адрес вышлем ссылку для создания нового пароля",
  "public.app.page.login.enterEmail": "Укажите эл. почту",
  "public.app.page.login.forgetPassword": "Забыл пароль",
  "public.app.page.login.changePasswordError": "неверный email",
  "public.email.confirm.title": "Мы рады, что вы теперь с нами!",
  "public.email.confirm.subtitle": "Здравствуйте! Благодарим за регистрацию.",
  "public.email.confirm.subtitleInfo": "Для завершения регистрации подтвердите почту или пройдите по ссылке",
  "public.email.confirm.buttonText": "Подтвердить почту",
  "public.email.confirm.downloadPlan": "Получить план",
  "public.email.confirm.downloadChapche": "Скачать Сhapche",
  "public.email.confirm.infoText": "Вы получили это письмо, потому что воспользовались нашим сервисом",
  "public.email.confirm.contacts": "Остались вопросы? Пишите",
  "public.email.confirm.emailTheme": "Chapche. Вы зарегистрированы в приложении Chapche.",
  "public.email.forgotten.title": "Изменение пароля",
  "public.email.forgotten.downloadChapche": "Скачать Сhapche",
  "public.email.forgotten.infoText": "Вы получили это письмо, потому что воспользовались нашим сервисом",
  "public.email.forgotten.contacts": "Остались вопросы? Пишите",
  "public.email.forgotten.emailTheme": "Chapche. Ссылка на сброс пароля.",
  "public.email.forgotten.subtitle": "Для успешного изменения пароля воспользуйтесь кнопкой или пройдите по ссылке",
  "app.page.plan.select.now": "съесть сейчас",
  "app.page.plan.select.today": "съесть сегодня",
  "app.page.plan.select.tomorrow": "съесть завтра",
  "app.page.plan.select.week": "на неделю",
  "product.item.code.cashew": "кешью",
  "product.scheme.form.code.whole-nut": "Целый",
  "product.scheme.form.code.crushed-nut": "дробленый",
  "product.scheme.formGroup.syrup": "сироп",
  "app.page.plan.select.currentDay": "в этот день",
  "app.page.plan.select.nextDay": "на следующий день",
  "preference.scheme.when.currentDay": "в этот день",
  "preference.scheme.when.nextDay": "на следующий день",
  "meal.scheme.mealTime.after-morning": "бранч",
  "meal.scheme.mealTime.before-evening": "полдник",
  "meal.scheme.mealTime.night": "на ночь",
  "recipe.scheme.characteristic.taste.taste-sweet": "сладкий",
  "recipe.scheme.characteristic.taste.taste-salty": "соленый",
  "recipe.scheme.characteristic.taste.taste-sour": "кислый",
  "recipe.scheme.characteristic.taste.taste-spicy": "острый",
  "recipe.scheme.characteristic.taste.taste-bitter": "горький",
  "recipe.scheme.characteristic.taste.taste-umami": "умами",
  "app.page.recipe.recipeCharacteristic.taste": "вкус",
  "preference.scheme.preferenceType.recipe-characteristic": "характеристика рецепта",
  "product.scheme.property.code.chlorine": "Хлор",
  "product.scheme.property.code.iodine": "Йод",
  "product.scheme.property.code.fluorine": "Фтор",
  "product.scheme.property.code.cobalt": "Кобальт",
  "recipe.scheme.characteristic.source.source-chapche": "chapche",
  "recipe.scheme.characteristic.source.source-vkusvill": "вкусвилл",
  "app.page.recipe.recipeCharacteristic.source": "источник",
  "app.page.recipe.recipeName": "название рецепта",
  "recipe.item.type.salad": "Салат",
  "app.page.recipe.take-as-is": "Использовать рецепт как есть",
  "product.item.code.chicken": "Курица",
  "product.item.code.Iceberg-lettuce": "Салат айсберг",
  "product.item.code.egg-chicken": "Яйцо куриное",
  "product.item.code.mushroom": "Грибы",
  "product.item.code.champignon-mushroom": "Шампиньон",
  "product.scheme.formGroup.mushroom": "грибы",
  "product.item.code.olive": "оливки",
  "product.item.code.corn-salad": "салат корн",
  "product.item.code.rice-vinegar": "уксус рисовый",
  "product.item.code.turkey": "индейка",
  "product.item.code.onion-green": "зелёный лук",
  "product.item.code.zucchini": "цукини",
  "product.item.code.parsley-greens": "петрушка",
  "product.item.code.mayonnaise": "майонез",
  "product.item.code.soy-sauce": "соевый соус",
  "product.item.code.bulgur": "булгур",
  "product.item.code.beet-root": "свёкла",
  "product.item.code.sesame-seeds": "Семена кунжута",
  "product.item.code.cilantro": "кинза",
  "product.item.code.feta": "фета",
  "product.item.code.arugula": "руккола",
  "product.item.code.spinach": "шпинат",
  "product.item.code.garlic": "чеснок",
  "product.item.code.sugar": "сахар",
  "product.item.code.salt": "соль",
  "product.item.code.green-peas": "горошек",
  "product.item.code.black-pepper": "перец чёрный",
  "product.item.code.chili-pepper": "перец чили",
  "product.item.code.sunflower-oil": "подсолнечное масло",
  "product.item.code.pumpkin": "тыква",
  "product.item.code.white-cabbage": "Капуста белокочанная",
  "product.item.code.lemon": "Лимон",
  "meal.scheme.mealType.salad": "салат",
  "product.item.code.sweet-pepper": "сладкий перец",
  "product.item.code.dill-greens": "укроп",
  "product.item.code.apple-cider-vinegar": "яблочный уксус",
  "product.item.code.quail-eggs": "яйцо перепелиное",
  "product.item.code.tofu": "Тофу",
  "product.item.code.radish": "редис",
  "product.item.code.gouda-cheese": "сыр Гауда",
  "product.item.code.pomegranate": "гранат",
  "product.item.code.chickpeas": "нут",
  "product.item.code.romaine-lettuce": "салат романо",
  "product.item.code.ginger": "имбирь",
  "product.item.code.wine-vinegar": "винный уксус",
  "product.item.code.onion": "лук репчатый",
  "product.item.code.beef-broth": "Говяжий бульон",
  "product.item.code.celery-root": "Корень сельдерея",
  "product.scheme.property.code.broth": "бульон",
  "meal.scheme.mealType.omelette": "омлет",
  "product.item.code.wheat-noodles": "Лапша пшеничная",
  "product.item.code.soy-sprouts": "Соевые ростки",
  "product.item.code.beef": "Говядина",
  "product.item.code.bacon-shpik": "Шпик",
  "product.item.code.seaweed": "Морская капуста",
  "product.item.code.bay-leaf": "Лавровый лист",
  "product.item.code.chicken-broth": "Куриный бульон",
  "product.item.code.tomato-paste": "Томатная паста",
  "product.item.code.milk-cream": "Сливки",
  "product.item.code.table-vinegar": "уксус столовы",
  "product.item.code.cucumber-pickled": "Огурец солёный",
  "product.item.code.mushroom-broth": "грибной бульон",
  "product.item.code.turmeric": "Куркума",
  "product.item.code.nutmeg": "Мускатный орех",
  "product.item.code.rice-noodles": "Лапша рисовая",
  "product.item.code.pink-salmon-filet": "Филе горбуши",
  "product.item.code.mung-sprouts": "Ростки фасоли маш",
  "product.item.code.milk": "молоко коровье",
  "product.item.code.zander-filet": "Филе судака",
  "product.item.code.halibut-filet": "филе палтуса",
  "product.item.code.water": "Вода питьевая",
  "recipe.item.type.omelette": "омлет",
  "recipe.scheme.recipeType.omelette": "омлет",
  "recipe.scheme.recipeType.salad": "салат",
  "product.scheme.formGroup.broth": "бульон",
  "product.scheme.property.code.water": "вода",
  "app.page.product.filters.water": "вода",
  "app.page.form.filters.water": "вода",
  "product.scheme.formGroup.water": "вода",
  "product.scheme.formGroup.liquid": "жидкость",
  "product.item.code.cinnamon": "Корица",
  "product.item.code.milk-lactose-free": "молоко коровье безлактозное",
  "product.item.code.almond-milk": "миндальное молоко",
  "product.item.code.millet": "пшено",
  "product.item.code.butter": "масло сливочное",
  "product.item.code.parmesan-cheese": "пармезан",
  "product.item.code.pesto-sauce": "соус песто",
  "product.item.code.peas-sprouts": "зелень проростков гороха",
  "product.item.code.couscous": "кускус",
  "product.item.code.coconut-pulp": "мякоть кокоса",
  "app.page.product.filters.recipeType": "тип рецепта",
  "product.item.code.peanut-butter": "арахисовая паста",
  "product.item.code.spelt": "полба",
  "product.item.code.flax-seeds": "семена льн",
  "product.item.code.coconut-milk": "кокосовое молоко",
  "product.item.code.prunes": "чернослив",
  "preference.scheme.preferenceType.combination": "сочетание",
  "product.item.code.mozzarella-cheese": "сыр моцарелла",
  "product.item.code.funchose": "фунчоза",
  "product.item.code.red-onion": "красный лук",
  "product.item.code.paprika": "паприка",
  "product.item.code.pear": "груша",
  "product.item.code.shrimps": "креветки",
  "product.item.code.avocado": "авокадо",
  "product.item.code.tuna": "тунец",
  "product.item.code.whole-wheat-bread": "цельнозерновой хлеб",
  "product.item.code.yogurt": "йогурт",
  "app.page.product.edit.image.base.title": "рисунок",
  "app.page.product.edit.image.parts.title": "частицы",
  "app.page.product.edit.image.base.color.label": "цвет фона",
  "app.page.product.edit.image.base.color.placeholder": "введите цвет",
  "app.page.product.edit.image.parts.color.label": "цвет частиц",
  "app.page.product.edit.image.parts.color.placeholder": "введите цвет частиц",
  "app.page.product.edit.image.part.label": "частица {0}",
  "app.page.product.edit.image.part.placeholder": "введите форму частицы",
  "app.page.product.edit.image.part.size.min.label": "min размер",
  "app.page.product.edit.image.part.size.max.label": "max размер",
  "app.page.product.edit.image.part.add": "добавить частицу",
  "app.page.product.edit.image.part.viewbox.label": "viewBox",
  "app.page.product.edit.image.part.viewbox.placeholder": "Введите viewBox",
  "app.page.product.edit.image.part.withoutbase.label": "Частица используется без базы",
  "app.page.preference.skip": "пропустить",
  "app.page.preference.preferencesInfo": "изменить выбранные предпочтения вы сможете в разделе \"Предпочтения\"",
  "app.page.recipe.recipeCharacteristic.product-category": "категория продукта",
  "preference.scheme.preferenceType.macronutrient-per-meal": "макронутриент в приём пищи",
  "preference.scheme.preferenceType.macronutrient-per-day": "макронутриент в день",
  "preference.scheme.preferenceType.product-category-per-meal": "категория продукта в приём пищи",
  "preference.scheme.preferenceType.product-category-per-day": "категория продукта в день",
  "meal.scheme.unit.gram": "грамм",
  "meal.scheme.unit.percentage": "процент",
  "meal.scheme.unit.pinch": "щепотка",
  "meal.scheme.unit.teaspoon": "чайная ложка",
  "meal.scheme.unit.tablespoon": "столовая ложка",
  "meal.scheme.unit.g-per-kg": "г/кг",
  "meal.scheme.unit.mg-per-kg": "мг/кг",
  "meal.scheme.unit.mcg-per-kg": "мкг/кг",
  "meal.scheme.unit.mg": "мг",
  "meal.scheme.unit.mcg": "мкг",
  "app.page.user.login.tg-admin-bot": "тг бот",
  "product.scheme.property.code.thiamine": "Тиамин (витамин В1)",
  "product.scheme.property.code.riboflavin": "Рибофлавин (Витамин В)"
};
export default ru;
